/* eslint-disable max-len */
import { array } from 'prop-types';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Api } from '../lib/api/api';
import { DATA_LATENCY_TYPE, ERROR_MESSAGE, ESysInfoAction } from '../lib/constants';
import utils from '../lib/utils';
import {
  SIM_ACTIVATION,
  eDataCenterStateAction,
  dataCenterMockResponse,
} from '../reducers/AppState/constants';
import store from '../store';
import { changeAction, resetBulkBoxSession } from './BoxSessionLogging';
import { eInterfacePriorty, eResetBoxActions } from '../reducers/UIState/EpikBoxes';
import favoriteBoxes from '../reducers/AppState/FavoriteBoxes';
import adminFlags from '../reducers/AppState/AdminFlags';

const CALL_HISTORY_ERROR_MESSAGE = 'Edge Device needs a firmware update';
const API_TOAST_ID = `API_OFFLINE_ERROR`;
const API_OFFLINE_ERROR = `Edge Device Offline or Unreachable`;
const API_TOAST_ID_NUMBER = `NUMBER_TRUNK_ERROR`;
const API_NUMBER_TRUNKS = `numberTrunks is not defined`;
let ERRPR_COUNT = 0;

const formatTime = time => {
  console.log(time)
  const [hours, minutes] = time.split(":").map(Number);
  let localTime = new Date();
  localTime.setHours(hours, minutes);
  // const utcTime = new Date(localTime.getTime() - localTime.getTimezoneOffset() * 60000);
  // console.log(utcTime.toISOString())
  return localTime.toISOString();
}

export const checkIfIsBoxTab = (body, skip) => {
  const { isBoxTab } = store.getState()?.UIState?.globals;
  const boxId = store.getState()?.AppState?.boxDetails?.box._id;

  if (body) {
    if (skip) {
      return {
        ...body,
        isBoxTab,
      };
    }
    return {
      ...body,
      isBoxTab,
      boxId,
    };
  }
  return {
    isBoxTab,
    boxId,
  };
};

export const getEpikBoxesData = (
  token,
  companyId,
  online,
  unmonitored,
  disablePagination,
  pagination,
  companyFilter = false,
) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'EPIK_BOXES',
  });
  try {
    const boxes = await api.boxes.getBoxes(
      companyId,
      online,
      unmonitored,
      disablePagination,
      pagination,
      companyFilter
    );
    boxes.docs &&
      boxes.docs.forEach(box => {
        box.Obis = getUniqueObis(box?.obis);
      });
    dispatch({
      type: 'EPIK_BOXES_SUCCESS',
      boxes,
    });
    return boxes;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'EPIK_BOXES_ERROR',
    });
    dispatch({
      type: 'EPIK_BOXES_ERROR',
      error,
    });
  }
};

export const getEpikBoxesSerial = (token, companyId, disablePagination, expansion) => async dispatch => {
  const api = new Api(token);
  dispatch({ type: 'EPIK_BOXES_SERIAL' });
  try {
    const boxesSerial = await api.boxes.getEpikBoxesSerial(companyId, disablePagination, expansion);
    dispatch({ type: 'EPIK_BOXES_SERIAL_SUCCESS', boxesSerial });
    return boxesSerial;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, { toastId: 'EPIK_BOXES_SERIAL_ERROR' });
    dispatch({ type: 'EPIK_BOXES_SERIAL_ERROR', error });
  }
};

export const enableStarCodes = (token, bid) => async dispatch => {
  const api = new Api(token);
  try {
    const enableStar = await api.boxes.enableStarCodes(bid, checkIfIsBoxTab());
    dispatch({ type: 'EPIK_BOXES_SUCCESS', boxes: enableStar });
    return enableStar;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'EPIK_BOXES_ERROR',
    });
    dispatch({ type: 'EPIK_BOXES_ERROR', error });
  }
};

export const enableBoxCallForward = (token, bid, boxOfflineCallForward, boxOfflineCallForwardNumber) => async dispatch => {
  const api = new Api(token);
  try {
    const enableStar = await api.boxes.enableBoxCallForward(bid ,boxOfflineCallForward, boxOfflineCallForwardNumber);
    dispatch({ type: 'EPIK_BOXES_SUCCESS', boxes: enableStar });
    toast.success("Call forwarding updated", {
      toastId: 'EPIK_BOXES_SUCCESS',
    });
    return enableStar;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'EPIK_BOXES_ERROR',
    });
    dispatch({ type: 'EPIK_BOXES_ERROR', error });
  }
};
export const selectedNotesTab = value => async dispatch => {
  dispatch({ type: 'SELECTED_NOTES_TAB', tab: value });
};

export const setPriFailoversList = data => async dispatch => {
  dispatch({ type: 'SET_PRI_FAILOVERS_LIST', data });
};

export const setCasFailoversList = data => async dispatch => {
  dispatch({ type: 'SET_CAS_FAILOVERS_LIST', data });
};

export const notesTabFilters = value => async dispatch => {
  dispatch({ type: 'NOTES_TAB_FILTERS', filters: value });
};

export const resetStarCodes = (token, bid) => async dispatch => {
  const api = new Api(token);
  try {
    const resetStarCode = await api.boxes.resetStarCodes(bid, checkIfIsBoxTab());
    dispatch({ type: 'RESET_STAR_CODES_SUCCESS', resetStarCode });
    toast.success(resetStarCode?.message || 'Star codes reset successfully');
    return resetStarCode;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'EPIK_BOXES_ERROR',
    });
    dispatch({ type: 'EPIK_BOXES_ERROR', error });
  }
};

export const getBoxesByGroupIDAction = (token, companyId, pagination) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'EPIK_BOXES',
  });
  try {
    const boxes = await api.boxes.getBoxesByGroupID(companyId, pagination);
    dispatch({
      type: 'EPIK_BOXES_SUCCESS',
      boxes,
    });
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'EPIK_BOXES_ERROR',
    });
    dispatch({
      type: 'EPIK_BOXES_ERROR',
      error,
    });
  }
};

export const getEpikBoxesDataByLocation = (
  token,
  locationId,
  companyId,
  pagination,
) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'EPIK_BOXES_BY_LOCATION',
  });
  try {
    const boxes = await api.boxes.getBoxesByLocation(locationId, companyId, pagination);
    const box = boxes.docs;
    // boxes.forEach(box => {
    //   box.Obis = getUniqueObis(box.obis);
    // });
    dispatch({
      type: 'EPIK_BOXES_SUCCESS',
      boxes: box,
    });
    return box;
  } catch (error) {
    toast.error('No Edge Devices with specified location Id');
    dispatch({
      type: 'EPIK_BOXES_ERROR',
      error,
    });
    return false;
  }
};

export const mapLocationsFilter = (token, type, value) => async dispatch => {
  const api = new Api(token);
  try {
    const epikBoxLocations = await api.boxes.mapLocationsFilter(type, value);
    dispatch({
      type: 'EPIK_BOX_LOCATION_SUCCESS',
      epikBoxLocations,
    });
  } catch (error) {
    dispatch({
      type: 'EPIK_BOX_LOCATION_ERROR',
      error,
    });
  }
};

export const filteredLocationBoxes = boxes => async dispatch => {
  dispatch({
    type: 'EPIK_BOXES_SUCCESS',
    boxes,
  });
};

// export const getAllBoxes = (token) => async dispatch => {
//   const api = new Api(token);
//   dispatch({
//     type: 'ALL_EPIK_BOXES',
//   });
//   try {
//     const allBoxes = await api.boxes.getAllBoxes();
//     dispatch({
//       type: 'ALL_EPIK_BOXES_SUCCESS',
//       allBoxes,
//     });
//   } catch (error) {
//     dispatch({
//       type: 'ALL_EPIK_BOXES_ERROR',
//       error,
//     });
//   }
// };

export const getEpikBoxesDataByObi = (token, obiNumber, online, pagination) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'EPIK_BOXES',
  });
  try {
    const boxes = await api.boxes.getEpikBoxesDataByObi(obiNumber, online, pagination);
    const box = boxes;
    dispatch({
      type: 'EPIK_BOXES_SUCCESS',
      boxes: box,
    });
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'EPIK_BOXES_ERROR',
    });
    dispatch({
      type: 'EPIK_BOXES_ERROR',
      error,
    });
  }
};

export const setBoxPagination = options => async dispatch => {
  dispatch({
    type: 'SET_BOX_PAGINATION',
    options,
  });
};

export const clearBoxPagination = () => async dispatch => {
  dispatch({
    type: 'CLEAR_BOX_PAGINATION',
  });
};

export const getEpikUnassignedBoxesData = token => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'EPIK_UNASSIGNED_BOXES',
  });
  try {
    const boxes = await api.boxes.getEpikUnassignedBoxesData();
    const box = boxes;
    dispatch({
      type: 'EPIK_UNASSIGNED_BOXES_SUCCESS',
      boxes: box,
    });
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'EPIK_UNASSIGNED_BOXES_ERROR',
    });
    dispatch({
      type: 'EPIK_UNASSIGNED_BOXES_ERROR',
      error,
    });
  }
};

export const getEpikBoxesBySerialNumber = (
  token,
  serialNumber,
  online,
  pagination,
) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'EPIK_BOXES_BY_SERIAL_NUMBER',
  });
  try {
    const boxes = await api.boxes.getEpikBoxesBySerialNumber(serialNumber, online, pagination);
    const box = boxes;
    dispatch({
      type: 'EPIK_BOXES_SUCCESS',
      boxes: box,
    });
    if (!box?.docs?.length) {
      toast.error(`No box found against ${serialNumber} `);
    }
    return box;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'EPIK_BOXES_ERROR',
    });
    dispatch({
      type: 'EPIK_BOXES_ERROR',
      error,
    });
  }
};

export const getEpikBoxesByFavorites = (token, online, pagination) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'EPIK_BOXES_BY_FAVORITES',
  });
  try {
    const boxes = await api.boxes.getEpikBoxesByFavorites(pagination);
    const box = boxes;
    dispatch({
      type: 'EPIK_BOXES_SUCCESS',
      boxes: box,
    });

    dispatch({
      type: 'FAVORITE_BOXES_SUCCESS',
      favoriteBoxes: box?.docs,
    });

    return box;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: `EPIK_BOXES_ERROR`,
    });
    dispatch({
      type: 'EPIK_BOXES_ERROR',
      error,
    });
  }
};

export const getEpikBoxesByStatus = (token, status, online, pagination) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'EPIK_BOXES_BY_SERIAL_NUMBER',
  });
  try {
    const boxes = await api.boxes.getEpikBoxesByStatus(status, online, pagination);
    const box = boxes;
    dispatch({
      type: 'EPIK_BOXES_SUCCESS',
      boxes: box,
    });
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'EPIK_BOXES_ERROR',
    });
    dispatch({
      type: 'EPIK_BOXES_ERROR',
      error,
    });
  }
};

export const getEpikBoxesByTrackingNumber = (
  token,
  trackingNumber,
  online,
  pagination,
) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'EPIK_BOXES_BY_SHIPPING_TRACKING_NUMBER',
  });
  try {
    const boxes = await api.boxes.getEpikBoxesByTrackingNumber(trackingNumber, online, pagination);
    const box = boxes;
    dispatch({
      type: 'EPIK_BOXES_SUCCESS',
      boxes: box,
    });
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'EPIK_BOXES_ERROR',
    });
    dispatch({
      type: 'EPIK_BOXES_CLEAR',
      error,
    });
  }
};

export const getEpikBoxesByAssignedNumber = (
  token,
  assignedNumber,
  online,
  pagination,
) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'EPIK_BOXES_BY_ASSIGNED_NUMBER',
  });
  try {
    const boxes = await api.boxes.getEpikBoxesByAssingedNumber(assignedNumber, online, pagination);
    const box = boxes;
    dispatch({
      type: 'EPIK_BOXES_SUCCESS',
      boxes: box,
    });
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'EPIK_BOXES_ERROR',
    });
    dispatch({
      type: 'EPIK_BOXES_CLEAR',
      error,
    });
  }
};
export const getEpikBoxesByVPNAddress = (token, vpnaddress, pagination) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'EPIK_BOXES_BY_VPN_ADDRESS',
  });
  try {
    const boxes = await api.boxes.getEpikBoxesByVPNAddress(vpnaddress, pagination);
    const box = boxes;
    dispatch({
      type: 'EPIK_BOXES_SUCCESS',
      boxes: box,
    });
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'EPIK_BOXES_ERROR',
    });
    dispatch({
      type: 'EPIK_BOXES_CLEAR',
      error,
    });
  }
};
export const getEpikBoxesDataByName = (token, boxName, online, pagination) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'EPIK_BOXES',
  });
  try {
    const boxes = await api.boxes.getEpikBoxesDataByName(boxName, online, pagination);
    const box = boxes;
    dispatch({
      type: 'EPIK_BOXES_SUCCESS',
      boxes: box,
    });
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'EPIK_BOXES_ERROR',
    });
    dispatch({
      type: 'EPIK_BOXES_ERROR',
      error,
    });
  }
};

export const getEpikBoxesByAdSearch = (token, params, pagination) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'EPIK_BOXES',
  });
  try {
    const boxes = await api.boxes.getEpikBoxesByAdSearch(params, pagination);
    const box = boxes;
    dispatch({
      type: 'EPIK_BOXES_SUCCESS',
      boxes: box,
    });
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'EPIK_BOXES_ERROR',
    });
    dispatch({
      type: 'EPIK_BOXES_ERROR',
      error,
    });
  }
};

export const getBoxCount = (token, companyId) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'BOX_COUNT',
  });
  try {
    const boxCount = await api.boxes.getBoxCount(companyId);
    dispatch({
      type: 'BOX_COUNT_SUCCESS',
      boxes: boxCount,
    });
    return boxCount;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'BOX_COUNT_ERROR',
    });
    dispatch({
      type: 'BOX_COUNT_ERROR',
      error,
    });
  }
};

export const bulkAssignEpikBox = (token, data) => async dispatch => {
  const api = new Api(token);
  const res = await api.boxes.bulkAssignEpikBox(checkIfIsBoxTab(data, true));
  return res;
};

export const SetSelectedBoxes = boxes => async dispatch => {
  dispatch({ type: 'SET_SELECTED_BOXES', data: boxes });
};

export const InitiateAlarm = timer => async dispatch => {
  dispatch({ type: 'INITIATE_ALARM_TIMER', timer });
};

export const FetchResultVisible = status => async dispatch => {
  dispatch({ type: 'FETCH_RESULT_VISIBLE', status });
};

export const selectedProtocol = data => async dispatch => {
  dispatch({ type: 'SELECTED_PROTOCOL_DATA', data });
};

export const enhancedRouting = (token, boxId, toggle) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'ENHANCED_ROUTING',
  });
  try {
    await api.boxes.enhancedRouting(boxId, toggle, checkIfIsBoxTab());
    dispatch({
      type: 'ENHANCED_ROUTING_SUCCESS',
    });
    return true;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'ENHANCED_ROUTING_ERROR',
    });
    dispatch({
      type: 'ENHANCED_ROUTING_ERROR',
      error,
    });
  }
};

export const changeBoxRegistrar = (token, boxId, toggle) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'BOX_REGISTRAR_CHANGE',
  });
  try {
    await api.boxes.changeBoxRegistrar(boxId, toggle);
    dispatch({
      type: 'BOX_REGISTRAR_CHANGE_SUCCESS',
    });
    return true;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'BOX_REGISTRAR_CHANGE_ERROR',
    });
    dispatch({
      type: 'BOX_REGISTRAR_CHANGE_ERROR',
      error,
    });
  }
};

export const addUnAuthNote = (id, obj) => async dispatch => {
  const api = new Api();
  dispatch({
    type: 'ADD_UN_AUTH_NOTE',
  });
  try {
    await api.boxes.addUnAuthNote(id, checkIfIsBoxTab(obj));
    dispatch({
      type: 'ADD_UN_AUTH_NOTE_SUCCESS',
    });
    toast.success('Note added successfully!');
    return true;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'ADD_UN_AUTH_NOTE_ERROR',
    });
    dispatch({
      type: 'ADD_UN_AUTH_NOTE_ERROR',
      error,
    });
  }
};

export const alarmProtocolToggle = (token, bid, body) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'ALARM_PROTOCOL_TOGGLE',
  });
  try {
    const alarmProtocolToggleResponse = await api.boxes.alarmProtocolToggle(
      bid,
      checkIfIsBoxTab(body),
    );
    dispatch({
      type: 'ALARM_PROTOCOL_TOGGLE_SUCCESS',
      alarmProtocolToggle: alarmProtocolToggleResponse,
    });
    if (alarmProtocolToggleResponse?.success === false) {
      toast.info(alarmProtocolToggleResponse?.message);
      return false;
    }
    return alarmProtocolToggleResponse;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'ALARM_PROTOCOL_TOGGLE_ERROR',
    });
    dispatch({
      type: 'ALARM_PROTOCOL_TOGGLE_ERROR',
      error,
    });
  }
};

export const initiateAlarmTest = (token, bid, body) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'INITIATE_ALARM_TEST',
  });
  try {
    const initiateAlarmTest = await api.boxes.initiateAlarmTest(bid, checkIfIsBoxTab(body));
    dispatch({
      type: 'INITIATE_ALARM_TEST_SUCCESS',
      initiateAlarmTest,
    });
    return initiateAlarmTest;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'INITIATE_ALARM_TEST_ERROR',
    });
    dispatch({
      type: 'INITIATE_ALARM_TEST_ERROR',
      error,
    });
    return false;
  }
};

export const getAlarmTest = (token, bid) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_ALARM_TEST',
  });
  try {
    const getAlarmTest = await api.boxes.getAlarmTest(bid);
    dispatch({
      type: 'GET_ALARM_TEST_SUCCESS',
      getAlarmTest,
    });
    return getAlarmTest;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'GET_ALARM_TEST_ERROR',
    });
    dispatch({
      type: 'GET_ALARM_TEST_ERROR',
      error,
    });
  }
};

export const updateAlarmTest = (token, bid) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'UPDATE_ALARM_TEST',
  });
  try {
    const updateAlarmTest = await api.boxes.updateAlarmTest(bid);
    dispatch({
      type: 'UPDATE_ALARM_TEST_SUCCESS',
      updateAlarmTest,
    });
    return updateAlarmTest;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'UPDATE_ALARM_TEST_ERROR',
    });
    dispatch({
      type: 'UPDATE_ALARM_TEST_ERROR',
      error,
    });
  }
};

export const fetchAlarmResult = (token, bid, nid, obiId, portNumber) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'INITIATE_ALARM_TEST',
  });
  try {
    const fetchAlarmResultResponse = await api.boxes.fetchAlarmResult(bid, nid, obiId, portNumber);

    // const fetchAlarmResultResponse = {
    //   details: 'Kiss off took place after 11sec of CID creation',
    //   error: '',
    //   result: 'Failed',
    //   timeStamp: '2022-10-07 02:00:13.191667511 +0000 UTC',
    // };
    dispatch({
      type: 'INITIATE_ALARM_TEST_SUCCESS',
      fetchAlarmResultResponse,
    });
    return fetchAlarmResultResponse;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'INITIATE_ALARM_TEST_ERROR',
    });
    dispatch({
      type: 'INITIATE_ALARM_TEST_ERROR',
      error,
    });
  }
};

export const updateAlarmProtocol = (token, bid, body) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'UPDATE_ALARM_PROTOCOL',
  });
  try {
    const updateAlarmProtocol = await api.boxes.updateAlarmProtocol(bid, checkIfIsBoxTab(body));
    dispatch({
      type: 'UPDATE_ALARM_PROTOCOL_SUCCESS',
      updateAlarmProtocol,
    });
    return updateAlarmProtocol;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'UPDATE_ALARM_PROTOCOL_ERROR',
    });
    dispatch({
      type: 'UPDATE_ALARM_PROTOCOL_ERROR',
      error,
    });
  }
};

export const getSystemStatus = (token, boxId) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'SYSTEM_STATUS',
  });
  try {
    const systemStatus = await api.boxes.getSystemStatus(boxId);
    dispatch({
      type: 'SYSTEM_STATUS_SUCCESS',
      systemStatus,
    });
    return systemStatus;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'SYSTEM_STATUS_ERROR',
    });
    dispatch({
      type: 'SYSTEM_STATUS_ERROR',
      error,
    });
  }
};

export const addNote = (token, id, obj) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'ADD_NOTE',
  });
  try {
    await api.boxes.addNote(id, obj);
    dispatch({
      type: 'ADD_NOTE_SUCCESS',
    });
    return true;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'ADD_NOTE_ERROR',
    });
    dispatch({
      type: 'ADD_NOTE_ERROR',
      error,
    });
  }
};

export const postReleaseNote = (token, obj) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'POST_RELEASE_NOTE',
  });
  try {
    if (obj?.type === "Release Notes") {
      obj.publishTime = formatTime(obj?.publishTime);
    } else {
      obj.startTime = formatTime(obj?.startTime);
      obj.expireTime = formatTime(obj?.expireTime);
    }
    const data = await api.boxes.postReleaseNote(checkIfIsBoxTab(obj));
    dispatch({
      type: 'SET_MAINTENANCE_NOTE_SEEN_SUCCESS',
      data,
    });
    toast.success('Release note added successfully!');
    return true;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'POST_RELEASE_NOTE_ERROR',
    });
    dispatch({
      type: 'POST_RELEASE_NOTE_ERROR',
      error,
    });
    return false;
  }
};

export const getMaintenanceNotes = token => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_MAINTENANCE_NOTES',
  });
  try {
    const data = await api.boxes.getMaintenanceNotes();
    dispatch({
      type: 'GET_MAINTENANCE_NOTES_SUCCESS',
      data,
    });
    return data;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'GET_MAINTENANCE_NOTES_ERROR',
    });
    dispatch({
      type: 'GET_MAINTENANCE_NOTES_ERROR',
      error,
    });
  }
};

export const latestReleaseNote = token => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'LATEST_RELEASE_NOTE',
  });
  try {
    const data = await api.boxes.latestReleaseNote();
    dispatch({
      type: 'LATEST_RELEASE_NOTE_SUCCESS',
      data,
    });
    return data;
  } catch (error) {
    dispatch({
      type: 'LATEST_RELEASE_NOTE_ERROR',
      error,
    });
  }
};

export const setReleaseNoteSeen = token => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'SET_RELEASE_NOTE_SEEN',
  });
  try {
    const data = await api.boxes.setReleaseNoteSeen();
    dispatch({
      type: 'SET_RELEASE_NOTE_SEEN_SUCCESS',
      data,
    });
    return data;
  } catch (error) {
    dispatch({
      type: 'SET_RELEASE_NOTE_SEEN_ERROR',
      error,
    });
  }
};

export const getReleaseNotes = token => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_RELEASE_NOTES',
  });
  try {
    const data = await api.boxes.getReleaseNotes();
    dispatch({
      type: 'GET_RELEASE_NOTES_SUCCESS',
    });
    return data;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'GET_RELEASE_NOTES_ERROR',
    });
    dispatch({
      type: 'GET_RELEASE_NOTES_ERROR',
      error,
    });
  }
};

export const getNotes = (token, id, pagination) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_NOTE',
  });
  try {
    const boxNotes = await api.boxes.getNotes(id, pagination);
    dispatch({
      type: 'GET_NOTE_SUCCESS',
      boxNotes,
    });
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'GET_NOTE_ERROR',
    });
    dispatch({
      type: 'GET_NOTE_ERROR',
      error,
    });
  }
};

export const getFilterNotes = (
  token,
  id,
  queryFilter,
  pagination,
  shouldUpdateReduxState = true,
  sort,
) => async dispatch => {
  const api = new Api(token);
  if (shouldUpdateReduxState) {
    dispatch({
      type: 'GET_NOTE',
    });
  }
  try {
    const boxNotes = await api.boxes.getFilterNotes(id, queryFilter, pagination, sort);
    if (shouldUpdateReduxState) {
      dispatch({
        type: 'GET_NOTE_SUCCESS',
        boxNotes,
      });
    }
    return boxNotes;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'GET_NOTE_ERROR',
    });
    dispatch({
      type: 'GET_NOTE_ERROR',
      error,
    });
  }
};

export const onDeleteRecording = (token, noteId) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'DELETE_NOTE_RECORDING',
  });
  try {
    const deleteRecording = await api.boxes.onDeleteRecording(noteId);
    dispatch({
      type: 'DELETE_NOTE_RECORDING_SUCCESS',
      deleteRecording,
    });
    toast.success('Recording deleted successfully');
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'DELETE_NOTE_RECORDING_ERROR',
    });
    dispatch({
      type: 'DELETE_NOTE_RECORDING_ERROR',
      error,
    });
  }
};

export const getLogs = (token, boxid) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_LOGS',
  });
  try {
    const boxLogs = await api.boxes.getLogs(boxid);
    dispatch({
      type: 'GET_LOGS_SUCCESS',
      boxLogs,
    });
    return boxLogs;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'GET_LOGS_ERROR',
    });
    dispatch({
      type: 'GET_LOGS_ERROR',
      error,
    });
  }
};

export const filterLogs = boxLogs => async dispatch => {
  dispatch({
    type: 'FILTER_LOGS',
  });
  try {
    dispatch({
      type: 'GET_LOGS_SUCCESS',
      boxLogs,
    });
  } catch (error) {
    dispatch({
      type: 'GET_LOGS_ERROR',
      error,
    });
  }
};

export const editNote = (token, box_id, note, note_id) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'EDIT_NOTE',
  });
  try {
    await api.boxes.editNote(box_id, note, note_id);
    dispatch({
      type: 'EDIT_NOTE_SUCCESS',
    });
    toast.success('Note edited successfully!');
    return true;
  } catch (error) {
    dispatch({
      type: 'EDIT_NOTE_ERROR',
      error,
    });
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'EDIT_NOTE_ERROR',
    });
  }
};

export const reloadEpiInfo = (token, box_id) => async dispatch => {
  const api = new Api(token);
  try {
    await api.boxes.reloadEpiInfo(box_id, checkIfIsBoxTab());
    dispatch({
      type: 'RELOAD_EPI_SUCCESS',
    });
    toast.success('Reloaded successfully!');
    return true;
  } catch (error) {
    dispatch({
      type: 'RELOAD_EPI_ERROR',
      error,
    });
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'RELOAD_EPI_ERROR',
    });
  }
};

export const deleteNote = (token, box_id, note_id) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'DELETE_NOTE',
  });
  try {
    await api.boxes.deleteNote(box_id, note_id);
    dispatch({
      type: 'DELETE_NOTE_SUCCESS',
    });
    toast.success('Note deleted successfully!');
    return true;
  } catch (error) {
    dispatch({
      type: 'DELETE_NOTE_ERROR',
      error,
    });
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'DELETE_NOTE_ERROR',
    });
  }
};

export const analyzeRecording = (token, note_id) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'ANALYZE_ATTACHMENT',
  });
  try {
    let data = await api.boxes.analyzeRecording(note_id);
    dispatch({
      type: 'ANALYZE_ATTACHMENT_SUCCESS',
    });
    return data;
  } catch (error) {
    dispatch({
      type: 'ANALYZE_ATTACHMENT_ERROR',
      error,
    });
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'ANALYZE_ATTACHMENT_ERROR',
    });
  }
};
export const downloadAttachment = (token, note_id, fileName, noDownload) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'DOWNLOAD_ATTACHMENT',
  });
  try {
    let data = await api.boxes.downloadAttachment(note_id, fileName, noDownload);
    dispatch({
      type: 'DOWNLOAD_ATTACHMENT_SUCCESS',
    });
    if (noDownload) return data;
    return true;
  } catch (error) {
    dispatch({
      type: 'DOWNLOAD_ATTACHMENT_ERROR',
      error,
    });
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'DOWNLOAD_ATTACHMENT_ERROR',
    });
  }
};

export const getEpikBoxesDetail = (token, companyId, paginateOptions) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'EPIK_BOXES',
  });
  try {
    const boxesList = await api.boxes.getBoxesDetail(companyId, paginateOptions);
    if (companyId) {
      dispatch({
        type: 'EPIK_BOXES_SUCCESS',
        boxes: boxesList,
      });
      return;
    }
    dispatch({
      type: 'EPIK_BOXES_LIST_SUCCESS',
      boxesList,
    });
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'EPIK_BOXES_LIST_ERROR',
    });
    dispatch({
      type: 'EPIK_BOXES_LIST_ERROR',
      error,
    });
  }
};

export const getPopulateBoxes = (token, companyId) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'EPIK_BOXES',
  });
  try {
    const boxesData = await api.boxes.getPopulateBoxes(companyId);
    dispatch({
      type: 'EPIK_BOXES_SUCCESS',
      boxes: boxesData,
    });
    return boxesData;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'EPIK_BOXES_ERROR',
    });
    dispatch({
      type: 'EPIK_BOXES_ERROR',
      error,
    });
  }
};

export const getEpikBoxLocations = token => async dispatch => {
  const api = new Api(token);
  try {
    const epikBoxLocations = await api.boxes.getEpikBoxLocations();
    dispatch({
      type: 'EPIK_BOX_LOCATION_SUCCESS',
      epikBoxLocations,
    });
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'EPIK_BOX_LOCATION_ERROR',
    });
    dispatch({
      type: 'EPIK_BOX_LOCATION_ERROR',
      error,
    });
  }
};

function getUniqueObis(obis) {
  const uniqueObis = [];
  obis.forEach(obi => {
    if (uniqueObis.findIndex(({ _id }) => obi._id === _id) === -1) {
      uniqueObis.push(obi);
    } else {
      console.warn('Multiple EPIs found in a box. This should not happen.');
    }
  });
  return uniqueObis;
}

export const updateBoxData = data => async dispatch => {
  const box = { ...data };
  box.Obis = getUniqueObis(box?.Obis);
  // return only unique obis from box
  if (box.myEpik) {
    global.myEpik = 'Yes';
  } else {
    global.myEpik = 'No';
  }
  dispatch({
    type: 'EPIK_BOX_SUCCESS',
    box,
  });
};

export const getEpikBoxData = (token, boxId) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'EPIK_BOX',
  });
  try {
    const box = await api.boxes.getBox(boxId);
    dispatch(updateBoxData(box));
    return box;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'EPIK_BOX_ERROR',
    });
    dispatch({
      type: 'EPIK_BOX_ERROR',
      error,
    });
  }
};

export const getLiveCallFeature = (token, boxId) => async dispatch => {
  const api = new Api(token);
  try {
    const box = await api.boxes.getLiveCallFeature(boxId);
    return box;
  } catch (error) {
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'EPIK_BOX_ERROR',
    });
    dispatch({
      type: 'EPIK_BOX_ERROR',
      error,
    });
  }
};
export const getCurrentAtaVersions = (token, vpnAddress) => async dispatch => {
  const api = new Api(token);
  try {
    const currentAtaVersions = await api.boxes.getCurrentAtaVersions(vpnAddress);
    return currentAtaVersions;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'EPIK_BOX_ERROR',
    });
  }
};

export const getInitiatePing = (token, vpnaddress, type) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'EPIK_BOX',
  });
  try {
    const response = await api.boxes.getPing(vpnaddress, type);
    if (response.Error == '') {
      toast.success(response.Response);
    } else {
      toast.error(response.Error);
    }
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'EPIK_BOX_ERROR',
    });
  }
};
export const getFetchPingResult = (token, vpnaddress, type) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'EPIK_BOX',
  });
  try {
    const response = await api.boxes.getFetchPing(vpnaddress, type);

    if (response && response.Error == '') {
      return response;
    } else {
      toast.error(response.Error);
    }
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'EPIK_BOX_ERROR',
    });
    return false;
  }
};
export const getDCData = (token) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'EPIK_DC_DATA',
  });
  try {
    const box = await api.boxes.getDCData();
    dispatch({
      type: 'EPIK_DC_DATA_SUCCESS',
      box,
    });
    return box;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'EPIK_DC_DATA_ERROR',
    });
    dispatch({
      type: 'EPIK_DC_DATA_ERROR',
      error,
    });
  }
};

export const getSignalStrength = (token, boxId) => async dispatch => {
  const api = new Api(token);
  try {
    const signal = await api.boxes.getSignalStrength(boxId);
    dispatch({
      type: 'EPIK_BOX_SINGNAL_SUCCESS',
      signal,
    });
    return signal;
  } catch (error) {
    dispatch({
      type: 'EPIK_BOX_SINGNAL_ERROR',
      signal: null,
    });
  }
};

export const getBoxPower = (token, boxId) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'EPIK_BOX_POWER',
  });
  try {
    const boxPower = await api.boxes.getBoxPower(boxId);
    dispatch({
      type: 'EPIK_BOX_POWER',
      boxPower,
    });
    return boxPower.powerState;
  } catch (error) {
    // Error Message from API
    if (error?.response?.data === API_OFFLINE_ERROR) {
      toast.error(error?.response?.data || ERROR_MESSAGE, {
        toastId:
          error?.response?.data === API_OFFLINE_ERROR ? API_TOAST_ID : 'EPIK_BOX_POWER_ERROR',
      });
      ERRPR_COUNT = 0;
    } else {
      toast.error(error?.response?.data || ERROR_MESSAGE, {
        toastId: 'EPIK_BOX_POWER_ERROR',
      });
    }
    dispatch({
      type: 'EPIK_BOX_POWER_ERROR',
      error,
    });
    return error?.response?.data === API_OFFLINE_ERROR ||
      error?.response?.data.includes(`ETIMEDOUT`) ||
      error?.response?.data.includes(`ENOTFOUND`) ||
      error?.response?.data.includes(`ENETUNREACH`)
      ? API_OFFLINE_ERROR
      : ``;
  }
};

// eslint-disable-next-line consistent-return
export const getRestStatus = (token, boxId) => async () => {
  const api = new Api(token);
  try {
    await api.boxes.getRestStatus(boxId);
    return true;
  } catch (error) {
    // Error Message from API
    utils.execute510Handler(error, 'EPIK_BOX_REST_STATUS_ERROR');
  }
};

export const getBoxCarrier = (token, boxId) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.boxes.getBoxCarrier(boxId);
    // return data?.modemInfo?.networkCarrier || 'None';
    return data || 'None';
  } catch (error) {
    // Error Message from API
    return 'None';
    utils.execute510Handler(error, 'EPIK_BOX_Carrier_info_ERROR');
  }
};
export const updateNumberRouteAndTrunk = (token, boxId) => async () => {
  const api = new Api(token);
  try {
    await api.boxes.updateNumberRouteAndTrunk(boxId);
    return true;
  } catch (error) {
    // Error Message from API
    const errorMsg = error?.response?.data || ERROR_MESSAGE;
    if (errorMsg === API_NUMBER_TRUNKS) {
      toast.error(errorMsg, { toastId: API_TOAST_ID_NUMBER });
    }
     else {
      utils.objectErrorHandler(error);
    }
  }
};
export const checkNumberRouteAndTrunk = (token, boxId) => async () => {
  const api = new Api(token);
  try {
    await api.boxes.checkNumberRouteAndTrunk(boxId);
    return true;
  } catch (error) {
    // Error Message from API
    const errorMsg = error?.response?.data || ERROR_MESSAGE;
    if (errorMsg === API_NUMBER_TRUNKS) {
      toast.error(errorMsg, { toastId: API_TOAST_ID_NUMBER });
    }
     else {
      utils.objectErrorHandler(error);
    }
  }
};

export const trunkPortConfig = (token, body,showToast = true) => async dispatch => {
  const api = new Api(token);

  try {
    const res = await api.boxes.trunkPortConfig(checkIfIsBoxTab(body));
    if(showToast)
      toast.success(res);
    return res;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'TRUNK_PORT_CONFIG_ERROR',
    });
    dispatch({
      type: 'TRUNK_PORT_CONFIG_ERROR',
      error,
    });
  }
};

export const boundForwardNumber = (token, bid, body) => async dispatch => {
  const api = new Api(token);

  try {
    const res = await api.boxes.boundForwardNumber(bid, checkIfIsBoxTab(body));
    toast.success('Outbound added successfully!');
    return res;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'BOUND_FORWARD_NUMBER_ERROR',
    });
    dispatch({
      type: 'BOUND_FORWARD_NUMBER_ERROR',
      error,
    });
  }
};

export const boundRemoveNumber = (token, bid, body) => async dispatch => {
  const api = new Api(token);

  try {
    const res = await api.boxes.boundRemoveNumber(bid, checkIfIsBoxTab(body));
    toast.success('Outbound removed successfully!');
    return res;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'BOUND_REMOVE_NUMBER_ERROR',
    });
    dispatch({
      type: 'BOUND_REMOVE_NUMBER_ERROR',
      error,
    });
  }
};

export const clearEpikBoxesData = () => dispatch => {
  dispatch({
    type: 'EPIK_BOXES_CLEAR',
  });
};

export const showCreateEpikBox = () => dispatch => {
  dispatch({
    type: 'CREATE_BOX_OPEN',
  });
};

export const cancelCreateEpikBox = () => dispatch => {
  dispatch({
    type: 'CREATE_BOX_CANCEL',
  });
};

export const getLocationByCompany = (token, cid) => async dispatch => {
  const api = new Api(token);
  try {
    const locations = await api.boxes.getLocationByCompany(cid);
    dispatch({
      type: 'GET_BOX_LOCATIONS_SUCCESS',
      locations,
    });
    return locations;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'GET_BOX_LOCATIONS_ERROR',
    });
    dispatch({
      type: 'GET_BOX_LOCATIONS_ERROR',
      error,
    });
  }
};

export const onRemoveLocation = (token, cid) => async dispatch => {
  const api = new Api(token);
  try {
    const locations = await api.boxes.onRemoveLocation(cid);
    dispatch({
      type: 'DELETE_BOX_LOCATIONS_SUCCESS',
      locations,
    });
    return true;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'DELETE_BOX_LOCATIONS_ERROR',
    });
    dispatch({
      type: 'DELETE_BOX_LOCATIONS_ERROR',
      error,
    });
  }
};

// eslint-disable-next-line consistent-return
export const boxConfig = (token, currBox, selectedBox, isExpansionModule = false) => async dispatch => {
  const api = new Api(token);
  try {
    const configStatus = await api.boxes.boxConfig(currBox, selectedBox, isExpansionModule);
    dispatch({
      type: 'BOX_CONFIG_SUCCESS',
      configStatus,
    });
    return configStatus;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'BOX_CONFIG_ERROR',
    });
    dispatch({
      type: 'BOX_CONFIG_ERROR',
      error,
    });
  }
};

// eslint-disable-next-line consistent-return
export const swapBoxObi = (token, currBox, selectedBox) => async dispatch => {
  const api = new Api(token);
  try {
    const configStatus = await api.boxes.swapBoxObi(currBox, selectedBox, checkIfIsBoxTab());
    if (configStatus?.success) {
      toast.success(configStatus.message);
    } else {
      toast.error(configStatus.message);
    }

    return configStatus;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'SWAP_BOX_OBI_ERROR',
    });
    dispatch({
      type: 'SWAP_BOX_OBI_ERROR',
      error,
    });
  }
};

export const onAddNewLocation = (token, cid, location) => async dispatch => {
  const api = new Api(token);
  try {
    const locations = await api.boxes.onAddNewLocation(cid, checkIfIsBoxTab(location));
    dispatch({
      type: 'ADD_BOX_LOCATIONS_SUCCESS',
      locations,
    });
    return true;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'ADD_BOX_LOCATIONS_ERROR',
    });
    dispatch({
      type: 'ADD_BOX_LOCATIONS_ERROR',
      error,
    });
  }
};

export const onUpdateLocation = (token, cid, location) => async dispatch => {
  const api = new Api(token);
  try {
    const locations = await api.boxes.onUpdateLocation(cid, checkIfIsBoxTab(location));
    dispatch({
      type: 'UPDATE_BOX_LOCATIONS_SUCCESS',
      locations,
    });
    return true;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'UPDATE_BOX_LOCATIONS_ERROR',
    });
    dispatch({
      type: 'UPDATE_BOX_LOCATIONS_ERROR',
      error,
    });
  }
};

export const showUpdateEpikBox = boxData => async dispatch => {
  const api = new Api(localStorage.getItem('jwtToken'));
  try {
    const box = await api.boxes.getBoxDetail(boxData);
    dispatch({
      type: 'UPDATE_BOX_OPEN',
      box,
    });
    return box;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'EPIK_BOXES_ERROR',
    });
    dispatch({
      type: 'EPIK_BOXES_ERROR',
      error,
    });
  }
};

export const getNumbers = (token, companyId) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_NUMBERS',
  });
  try {
    const numbers = await api.boxes.getNumbers(companyId);
    dispatch({
      type: 'GET_NUMBERS_SUCCESS',
      numbers,
    });
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'GET_NUMBERS_ERROR',
    });
    dispatch({
      type: 'GET_NUMBERS_ERROR',
      error,
    });
  }
};

export const editAssignedNumber = number => dispatch => {
  dispatch({
    type: 'EDIT_BOX_NUMBER_SHOW',
    number,
  });
};

export const unassingVmailNumber = (token, obiId, body) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.boxes.unassingVmailNumber(obiId, checkIfIsBoxTab(body));
    dispatch(updateBoxData(data));
    return true;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE);
    return false;
  }
};

export const getAssignedNumbers = (token, id, uid, priStatus) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'ASSIGNED_NUMBERS',
  });
  try {
    const assignedNumbers = await api.boxes.getAssignedNumbers(id, uid, priStatus);
    dispatch({
      type: 'ASSIGNED_NUMBERS_SUCCESS',
      assignedNumbers,
    });
    dispatch({
      type: 'ASSIGNED_COMPANY_NUMBERS_SUCCESS',
      assignedNumbers,
    });
    return assignedNumbers;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'ASSIGNED_NUMBERS_ERROR',
    });
    return dispatch({
      type: 'ASSIGNED_NUMBERS_ERROR',
      error,
    });
  }
};

export const modifyEditStatus = status => async dispatch => {
  dispatch({
    type: 'MODIFY_EDIT_STATUS_SUCCESS',
    status,
  });
};

export const getPortCallHistory = (token, boxId, portNumber) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'PORT_CALL_HISTORY',
  });
  try {
    const portCallHistory = await api.boxes.getPortCallHistory(boxId, portNumber);
    return dispatch({
      type: 'PORT_CALL_HISTORY_SUCCESS',
      portCallHistory,
    });
  } catch (error) {
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'PORT_CALL_HISTORY_ERROR',
    });
    // Error Message from API
    utils.execute510Handler(error, CALL_HISTORY_ERROR_MESSAGE);
  }
};

export const onRemoveAtaNumber = (token, ataNumber, body) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'ATA_NUMBER_REMOVE',
  });
  try {
    const removeAta = await api.boxes.onRemoveAtaNumber(ataNumber, checkIfIsBoxTab(body));
    dispatch({
      type: 'ATA_NUMBER_REMOVE_SUCCESS',
      removeAta,
    });
    toast.success('ATA Number Removed Successfully.');
    return removeAta;
  } catch (error) {
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'ATA_NUMBER_REMOVE_ERROR',
    });
    // Error Message from API
    utils.execute510Handler(error, CALL_HISTORY_ERROR_MESSAGE);
  }
};

export const onMonitorAtaNumber = (token, ataNumber, body) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'ATA_NUMBER_MONITOR',
  });
  try {
    const removeAta = await api.boxes.onMonitorAtaNumber(ataNumber, checkIfIsBoxTab(body));
    dispatch({
      type: 'ATA_NUMBER_MONITOR_SUCCESS',
      removeAta,
    });
    // toast.success('ATA Number Removed Successfully.');
    return removeAta;
  } catch (error) {
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'ATA_NUMBER_MONITOR_ERROR',
    });
    // Error Message from API
    utils.execute510Handler(error, CALL_HISTORY_ERROR_MESSAGE);
  }
};

export const getObiSystemStatus = (token, boxId, portNumber) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'OBI_SYSTEM_STATUS',
  });
  try {
    const portObiSystemStatus = await api.boxes.getObiSystemStatus(boxId, portNumber);
    return dispatch({
      type: 'OBI_SYSTEM_STATUS_SUCCESS',
      portObiSystemStatus,
    });
  } catch (error) {
    // Error Message from API
    utils.execute510Handler(error, CALL_HISTORY_ERROR_MESSAGE);
  }
};

export const getPortsRegStatus = (token, boxId) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.boxes.getPortsRegStatus(boxId);
    console.log("response in getPortsRegStatus ", data);
    return data;
  } catch (error) {
    console.log("Error in getPortsRegStatus Error ", error);
    console.log("Error in getPortsRegStatus Error Response ", error?.response);

    toast.error(error?.response?.data || 'something went wrong');
    return {success: false, response: error?.response?.status === 404 ? 
      'Edge Device Offline or Unreachable' : `Something went wrong, ${error?.message}!`};
  }
};


export const getPhysicalStatus = (token, boxId, portNumber) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'PHYSICAL_STATUS',
  });
  try {
    const portPhysicalStatus = await api.boxes.getPhysicalStatus(boxId, portNumber);
    return portPhysicalStatus;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || CALL_HISTORY_ERROR_MESSAGE, { error });
  }
};

export const getSimStatus = (token, body) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.boxes.getSimStatus(body);
    return data;
  } catch (error) {
    toast.error(error?.response?.data || 'something went wrong');
    return false;
  }
};

export const pingSim = (token, ip) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.boxes.pingSim(ip);
    return data;
  } catch (error) {
    toast.error(error?.response?.data || 'something went wrong');
  }
};

export const getSpeedTestInformation = serialNumber => async dispatch => {
  const api = new Api();
  dispatch({
    type: 'SPEED_TEST_INFO',
  });
  try {
    const speedTestInfo = await api.boxes.getSpeedTestInformation(serialNumber);
    return dispatch({
      type: 'SPEED_TEST_INFO_SUCCESS',
      speedTestInfo,
    });
  } catch (error) {
    // Error Message from API
    utils.execute510Handler(error, 'SPEED_TEST_INFO_ERROR');
    return dispatch({
      type: 'SPEED_TEST_INFO_ERROR',
      error,
    });
  }
};

export const getLteAnalyzer = (token, bid, vpnAddress) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'SPEED_TEST_INFO',
  });
  try {
    // eslint-disable-next-line no-shadow
    const getLteAnalyzer = await api.boxes.getLteAnalyzer(bid, vpnAddress);
    dispatch({
      type: 'GET_LTE_ANALYZER_SUCCESS',
      getLteAnalyzer,
    });
    if (getLteAnalyzer) toast.success('Successfully executed SIMs check utility.');
    else toast.error('Something went wrong while executed SIMs check utility.');
    return getLteAnalyzer;
  } catch (error) {
    // Error Message from API
    utils.execute510Handler(error, 'GET_LTE_ANALYZER_ERROR');
    return dispatch({
      type: 'GET_LTE_ANALYZER_ERROR',
      error,
    });
  }
};

export const getEngineeringLock = (token, bid) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_ENGINEERING_LOCK',
  });
  try {
    // eslint-disable-next-line no-shadow
    const lock = await api.boxes.getEngineeringLock(bid);
    dispatch({
      type: 'GET_ENGINEERING_LOCK_SUCCESS',
      engineeringLock: lock,
    });
    return lock;
  } catch (error) {
    return dispatch({
      type: 'GET_ENGINEERING_LOCK_ERROR',
      error,
    });
  }
};

export const addEngineeringLock = (token, bid) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'ADD_ENGINEERING_LOCK',
  });
  try {
    // eslint-disable-next-line no-shadow
    const lock = await api.boxes.addEngineeringLock(bid);
    dispatch({
      type: 'ADD_ENGINEERING_LOCK_SUCCESS',
    });
    return lock;
  } catch (error) {
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'ADD_ENGINEERING_LOCK_ERROR',
    });
    return dispatch({
      type: 'ADD_ENGINEERING_LOCK_ERROR',
      error,
    });
  }
};
export const deleteEngineeringLock = (token, bid) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'DELETE_ENGINEERING_LOCK',
  });
  try {
    // eslint-disable-next-line no-shadow
    const lock = await api.boxes.deleteEngineeringLock(bid);
    dispatch({
      type: 'DELETE_ENGINEERING_LOCK_SUCCESS',
    });
    return lock;
  } catch (error) {
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'DELETE_ENGINEERING_LOCK_ERROR',
    });
    return dispatch({
      type: 'DELETE_ENGINEERING_LOCK_ERROR',
      error,
    });
  }
};

export const getAdminFlags = (token, bid) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_ADMIN_FLAGS',
  });
  try {
    // eslint-disable-next-line no-shadow
    const adminFlags = await api.boxes.getAdminFlags(bid);
    dispatch({
      type: 'GET_ADMIN_FLAGS_SUCCESS',
      adminFlags,
    });
    return adminFlags;
  } catch (error) {
    return dispatch({
      type: 'GET_ADMIN_FLAGS_ERROR',
      error,
    });
  }
};

export const getUpDownSpeedInformation = (serialNumber, type) => async dispatch => {
  const api = new Api();
  dispatch({
    type: 'UP_DOWN_SPEED_INFO',
  });
  try {
    const speedTestInfo = await api.boxes.getUpDownSpeedInformation(serialNumber, type);
    return dispatch({
      type: 'UP_DOWN_SPEED_INFO_SUCCESS',
      speedTestInfo,
    });
  } catch (error) {
    // Error Message from API
    utils.execute510Handler(error, 'UP_DOWN_SPEED_INFO_ERROR');
    return dispatch({
      type: 'UP_DOWN_SPEED_INFO_ERROR',
      error,
    });
  }
};
export const setAssignedNumbers = (token, id, list) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'ASSIGNED_NUMBERS',
  });
  try {
    const setAssignedNumbers = await api.boxes.setAssignedNumbers(
      id,
      checkIfIsBoxTab({ numbers: list }),
    );
    toast.success('Numbers are assigned successfully.');
    return dispatch({
      type: 'SET_ASSIGNED_NUMBERS_SUCCESS',
      setAssignedNumbers,
    });
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'SET_ASSIGNED_NUMBERS_ERROR',
    });
    return dispatch({
      type: 'SET_ASSIGNED_NUMBERS_ERROR',
      error,
    });
  }
};

export const filterAssignedNumber = (token, number, bid) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'FILTER_ASSIGNED_NUMBERS',
  });
  try {
    const assignedNumbers = await api.boxes.filterAssignedNumber(number, bid);
    return dispatch({
      type: 'ASSIGNED_NUMBERS_SUCCESS',
      assignedNumbers,
    });
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'ASSIGNED_NUMBERS_ERROR',
    });
    return dispatch({
      type: 'ASSIGNED_NUMBERS_ERROR',
      error,
    });
  }
};

export const setImportNumbers = (token, list) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'IMPORT_NUMBERS',
  });
  try {
    const setImportNumbers = await api.boxes.setImportNumbers(checkIfIsBoxTab(list));
    toast.error('Numbers imported successfully.');
    return dispatch({
      type: 'SET_IMPORT_NUMBERS_SUCCESS',
      setImportNumbers,
    });
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'SET_IMPORT_NUMBERS_ERROR',
    });
    return dispatch({
      type: 'SET_IMPORT_NUMBERS_ERROR',
      error,
    });
  }
};

export const insertPhone = (token, boxId, obj) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'INSERT_PHONE',
  });
  try {
    const numbers = await api.boxes.insertPhone(boxId, checkIfIsBoxTab(obj));
    dispatch({
      type: 'INSERT_PHONE_SUCCESS',
      numbers,
    });
    toast.success('Phone added successfully!');
    return true;
  } catch (error) {
    dispatch({
      type: 'INSERT_PHONE_ERROR',
      error,
    });
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'INSERT_PHONE_ERROR',
    });
    return false;
  }
};

export const updatePhone = (token, phoneId, obj) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'UPDATE_PHONE',
  });
  try {
    const numbers = await api.boxes.updatePhone(phoneId, checkIfIsBoxTab(obj));
    dispatch({
      type: 'INSERT_PHONE_SUCCESS',
      numbers,
    });
    toast.success('Phone updated successfully!');
    return true;
  } catch (error) {
    dispatch({
      type: 'UPDATE_PHONE_ERROR',
      error,
    });
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'UPDATE_PHONE_ERROR',
    });
    return false;
  }
};

export const deletePhone = (token, phoneId) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'DELETE_PHONE',
  });
  try {
    await api.boxes.deletePhone(phoneId);
    dispatch({
      type: 'DELETE_PHONE_SUCCESS',
    });
    toast.success('Phone deleted successfully!');
    return true;
  } catch (error) {
    dispatch({
      type: 'DELETE_PHONE_ERROR',
      error,
    });
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'DELETE_PHONE_ERROR',
    });
    return false;
  }
};

export const showPhoneModal = () => dispatch => {
  dispatch({
    type: 'SHOW_PHONE_MODAL',
  });
};

export const hidePhoneModal = () => dispatch => {
  dispatch({
    type: 'HIDE_PHONE_MODAL',
  });
};

export const showNumberModal = () => dispatch => {
  dispatch({
    type: 'SHOW_NUMBER_MODAL',
  });
};

export const hideNumberModal = () => dispatch => {
  dispatch({
    type: 'HIDE_NUMBER_MODAL',
  });
};

export const cancelUpdateEpikBox = box => dispatch => {
  dispatch({
    type: 'UPDATE_BOX_CANCEL',
    box,
  });
  dispatch(resetBulkBoxSession());
};

export const showDeleteEpikBox = box => dispatch => {
  dispatch({
    type: 'DELETE_BOX_OPEN',
    box,
  });
};

export const cancelDeleteEpikBox = () => dispatch => {
  dispatch({
    type: 'DELETE_BOX_CANCEL',
  });
};

export const configurePort = (token, portConfigData) => async dispatch => {
  const api = new Api(token);
  // dispatch({
  //   type: 'EPIK_BOX_CREATE',
  //   box,
  // });
  try {
    await api.boxes.configurePort(checkIfIsBoxTab(portConfigData));
    // dispatch({
    //   type: 'EPIK_BOX_CREATE_SUCCESS',
    //   data,
    // });
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'ERROR',
    });
    // dispatch({
    //   type: 'EPIK_BOX_CREATE_ERROR',
    //   error,
    // });
  }
};
export const getSysInfo = (token, boxId, type = ESysInfoAction.OLD) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'SYS_INFO',
  });
  try {
    const data = await api.boxes.getSysInfo(boxId, ...Array(1), type);
    dispatch({
      type: 'SYS_INFO_SUCCESS',
      data,
    });
  } catch (error) {
    // Error Message from API
    dispatch({
      type: 'SYS_INFO_ERROR',
      error,
    });
  }
};

export const inititateSysInfo = (token, boxId) => async dispatch => {
  const api = new Api(token);
  try {
    const response = await api.boxes.inititateSysInfo(boxId);

    if (response.Error && response.Error != '') {
      toast.error(response.Error);
      return;
    }
    if (response.error == '') {
      toast.success(response.response);
      return;
    } else {
      toast.error(response.error);
      return;

    }
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'EPIK_BOX_ERROR',
    });
  }
};

export const sipDetails = (token, body) => async dispatch => {
  const api = new Api(token);

  try {
    await api.boxes.addSipInfo(body);
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'ERROR',
    });
  }
};

// SIP SAVE from ports
export const onSaveSip = (token, body) => async dispatch => {
  const api = new Api(token);

  try {
    await api.boxes.addSipSaveInfo(body);
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'ERROR',
    });
  }
};
// SIP
export const getSipPri = (token, bid, ispri) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.boxes.getSipPri(bid, ispri);

    if (ispri) {
      dispatch({
        type: 'SET_PRI_DATA_SUCCESS',
        priSettings: data?.priSettings,
      });
    } else {
      dispatch({
        type: 'SET_SIP_DATA_SUCCESS',
        sipSettings: data?.sipSettings,
      });
    }
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'ERROR',
    });
    return false;
  }
};

export const updateSipPri = (token, bid, ispri, body) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.boxes.updateSipPri(bid, ispri, checkIfIsBoxTab(body));
    toast.success('Number settings updated successfully');
    dispatch(getSipPri(token, bid, ispri))
    if (ispri) {
      dispatch({
        type: 'SET_PRI_DATA_SUCCESS',
        priSettings: data,
      });
    } else {
      dispatch({
        type: 'SET_SIP_DATA_SUCCESS',
        sipSettings: data,
      });
    }

    return data;
  } catch (error) {
    // Error Message from API
    dispatch(getSipPri(token, bid, ispri))
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'ERROR',
    });
  }
};

export const getPriStatus = (token, vpnAddress) => async dispatch => {
  console.log('priStatus :::vpnAddress :::', vpnAddress);
  const api = new Api(token);
  try {
    const data = await api.boxes.getPriStatus(vpnAddress);
    dispatch({
      type: 'SET_PRI_STATUS_SUCCESS',
      priStatus: data,
    });
    return data;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'ERROR',
    });
    return false;
  }
}

export const createEpikBox = (token, box) => async dispatch => {
  const api = new Api(token);

  dispatch({
    type: 'EPIK_BOX_CREATE',
    box,
  });
  try {
    const data = await api.boxes.createBox(checkIfIsBoxTab(box));
    dispatch({
      type: 'EPIK_BOX_CREATE_SUCCESS',
      data,
    });
    toast.success('New device is created.')
    return true;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'EPIK_BOX_CREATE_ERROR',
    });
    dispatch({
      type: 'EPIK_BOX_CREATE_ERROR',
      error,
    });
    return false;
  }
};

export const enableRecording = (token, bid, recordingDuration) => async dispatch => {
  const api = new Api(token);
  try {
    const resp =  await api.boxes.enableRecording(bid, checkIfIsBoxTab(), recordingDuration);
    if(resp){
      toast.success('Call recording enabled successfully.');
      return resp
    }
  } catch (error) {
    dispatch({
      type: 'ENABLE_RECORDING_ERROR',
      error,
    });
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'ENABLE_RECORDING_ERROR',
    });
  }
};

export const deleteEpikBox = (token, box) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'DELETE_BOX',
    box,
  });
  try {
    const data = await api.boxes.deleteBox(box);
    dispatch({
      type: 'EPIK_BOX_DELETE_SUCCESS',
      data,
    });
  } catch (error) {
    dispatch({
      type: 'EPIK_BOX_DELETE_ERROR',
      error,
    });
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'EPIK_BOX_DELETE_ERROR',
    });
  }
};

export const setBoxMonitorToggleState = (token, mode) => async dispatch => {
  dispatch({
    type: 'BOX_MONITOR_TOGGLE',
    mode,
  });
  dispatch(updateEpikBox(token, mode));
};

export const onRecover = (token, boxId) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'RECOVER_BOX',
  });
  try {
    await api.boxes.onRecover(boxId);
    dispatch({
      type: 'RECOVER_BOX_SUCCESS',
    });
    toast.success('Edge Device Recovered Successfully!');
    return true;
  } catch (error) {
    dispatch({
      type: 'RECOVER_BOX_FAILURE',
      error,
    });
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'RECOVER_BOX_FAILURE',
    });
  }
};

const getCurrentBoxIdFromURL = () => {
  const url = new URL(window.location.href);
  const pathname = url.pathname;
  return pathname.split('/').pop();
}

export const updateEpikBox = (token, box,expansionEnable) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'EPIK_BOX_UPDATE',
    box,
  });
  try {
    if (box._id) {
      const data = await api.boxes.updateBox(checkIfIsBoxTab(box),expansionEnable);

      // Added this check to avoid UI conflicts when adding/removing Expansion module
      const currentBoxId = getCurrentBoxIdFromURL()
      if (data && box._id === currentBoxId) {
        dispatch({
          type: 'EPIK_BOX_UPDATE_SUCCESS',
          data,
        });
        dispatch(updateBoxData(data));
        toast.success('Successfully updated Epik Edge Device');
      }
      return true;
    } else {
      return false;
    }
  } catch (error)
  {
    dispatch({
      type: 'EPIK_BOX_UPDATE_ERROR',
      error,
    });
    const errorMessage = error?.response?.data || ERROR_MESSAGE;
    const isEpiProvisioningDisabled = errorMessage.includes('failed to push config on cloud');
    toast.error(isEpiProvisioningDisabled ? 'EPI Provisioning is disabled' : errorMessage, {
      toastId: 'EPIK_BOX_UPDATE_ERROR',
    });
    return false;
  }
};

export const updateInterCalling = (token, bid, body) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'UPDATE_INTER_CALLING',
  });
  try {
    const result = await api.boxes.updateInterCalling(bid, checkIfIsBoxTab(body));
    if (result?.error) {
      toast.error(result?.error);
      return false;
    }
    dispatch({
      type: 'UPDATE_INTER_CALLING_SUCCESS',
    });
    console.log('result international ::', result);
    toast.success('International Calling updated successfully!');
    return true;
  } catch (error) {
    dispatch({
      type: 'UPDATE_INTER_CALLING_ERROR',
      error,
    });
    console.log('result international errror::', error);
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'UPDATE_INTER_CALLING_ERROR',
    });
    return false;
  }
};

export const activateEpikBox = (token, bid) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'ACTIVATE_EPIK_BOX',
    bid,
    token,
  });
  try {
    const data = await api.boxes.activateEpikBox(bid, checkIfIsBoxTab());
    dispatch({
      type: 'ACTIVATE_EPIK_BOX_SUCCESS',
      data,
    });
    toast.success('Successfully activated Epik Edge Device');
  } catch (error) {
    dispatch({
      type: 'ACTIVATE_EPIK_BOX_ERROR',
      error,
    });
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'ACTIVATE_EPIK_BOX_ERROR',
    });
  }
};

export const boxLockStatus = (token, bid) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'BOX_LOCK_STATUS',
    bid,
    token,
  });
  try {
    const data = await api.boxes.boxLockStatus(bid);
    dispatch({
      type: 'BOX_LOCK_STATUS_SUCCESS',
      data,
    });
    return data;
  } catch (error) {
    dispatch({
      type: 'BOX_LOCK_STATUS_ERROR',
      error,
    });
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'BOX_LOCK_STATUS_ERROR',
    });
  }
};

export const eSIMStatus = (token, bid) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.boxes.eSIMStatus(bid);
    dispatch({
      type: 'ESIM_STATUS_SUCCESS',
      data,
    });
    let valueOfInterest = false;
    if (
      JSON.stringify(data)
        .toLowerCase()
        .includes('backup')
    ) {
      valueOfInterest = true;
    }
    return valueOfInterest;
  } catch (error) {
    // commenting this error intentionally
    // toast.info(error?.response?.data?.code || error?.response?.data || 'SIM Swap unavailable.');
    return false;
  }
};

export const getPrimarySim = (token, bid) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.boxes.getPrimarySim(bid);
    dispatch({
      type: 'GET_PIMARY_SIM_SUCCESS',
      data,
    });

    return data;
  } catch (error) {
    // commenting this error intentionally
    // toast.info(error?.response?.data?.code || error?.response?.data || 'SIM Swap unavailable.');
    return false;
  }
};

export const setPrimarySim = (token, status, bid) => async () => {
  const api = new Api(token);
  try {
    const data = await api.boxes.setPrimarySim(status, bid, checkIfIsBoxTab());
    return data
  } catch (error) {
    toast.error(error?.response?.data || ERROR_MESSAGE);
    return { error, checks: false };
  }
};

export const addLockTime = (token, bid, showMessage) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'ADD_LOCK_TIME',
    bid,
    token,
  });
  try {
    const data = await api.boxes.addLockTime(bid);
    dispatch({
      type: 'ADD_LOCK_TIME_SUCCESS',
      data,
    });
    toast.success(data?.message);
  } catch (error) {
    dispatch({
      type: 'ADD_LOCK_TIME_ERROR',
      error,
    });
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'ADD_LOCK_TIME_ERROR',
    });
  }
};

export const releaseLock = (token, bid) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'RELEASE_LOCK',
    bid,
    token,
  });
  try {
    const data = await api.boxes.releaseLock(bid);
    dispatch({
      type: 'RELEASE_LOCK_SUCCESS',
      data,
    });
    toast.success(data?.message);
  } catch (error) {
    dispatch({
      type: 'RELEASE_LOCK_ERROR',
      error,
    });
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'RELEASE_LOCK_ERROR',
    });
  }
};

export const overrideLock = (token, bid) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'OVERRIDE_LOCK',
    bid,
    token,
  });
  try {
    const data = await api.boxes.overrideLock(bid);
    dispatch({
      type: 'OVERRIDE_LOCK_SUCCESS',
      data,
    });
    data.success
      ? toast.success(data?.message)
      : toast.error(data?.message);
  } catch (error) {
    dispatch({
      type: 'OVERRIDE_LOCK_ERROR',
      error,
    });
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'OVERRIDE_LOCK_ERROR',
    });
  }
};

export const boxLock = (token, bid) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'BOX_LOCK',
    bid,
    token,
  });
  try {
    const data = await api.boxes.boxLock(bid);
    dispatch({
      type: 'BOX_LOCK_SUCCESS',
      data,
    });
    const currentBoxId = getCurrentBoxIdFromURL()
    if (currentBoxId === bid) {
      toast.success('Record is now locked for editing.');
    }
    return true;
  } catch (error) {
    dispatch({
      type: 'BOX_LOCK_ERROR',
      error,
    });
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'BOX_LOCK_ERROR',
    });
    return false;
  }
};
export const getPortList = (token, bid) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_PORT_FORWARD_LIST',
    bid,
    token,
  });
  try {
    const data = await api.boxes.getPortList(bid);
    if (Array.isArray(data)) {
      dispatch({
        type: 'GET_PORT_FORWARD_LIST_SUCCESS',
        data,
      });
      return data;
    } else {
      toast.error(data);
      return [];
    }
  } catch (error) {
    utils.execute510Handler(error, 'GET_PORT_FORWARD_LIST_ERROR');
    dispatch({
      type: 'GET_PORT_FORWARD_LIST_ERROR',
      error,
    });
  }
};

export const addPortForward = (token, bid, obj) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.boxes.portForward(bid, checkIfIsBoxTab(obj));
    if (Array.isArray(data)) {
      dispatch({
        type: 'ADD_PORT_FORWARD_SUCCESS',
        data,
      });
      return data;
    } else {
      toast.error(data);
      return [];
    }
  } catch (error) {
    utils.execute510Handler(error, 'ADD_PORT_FORWARD_ERROR');
    dispatch({
      type: 'ADD_PORT_FORWARD_ERROR',
      error,
    });
    return false;
  }
};

export const updatePortForward = (token, bid, index, obj) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.boxes.updatePortForward(bid, index, checkIfIsBoxTab(obj));
    if (Array.isArray(data)) {
      dispatch({
        type: 'UPDATE_PORT_FORWARD_SUCCESS',
        data,
      });
      return data;
    } else {
      toast.error(data);
      return [];
    }
  } catch (error) {
    utils.execute510Handler(error, 'UPDATE_PORT_FORWARD_ERROR');
    dispatch({
      type: 'UPDATE_PORT_FORWARD_ERROR',
      error,
    });
    return false;
  }
};

export const getWifiStatus = (token, vpn) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.boxes.getWifiStatus(vpn);
    if (typeof data === 'string') throw new Error(data);
    return data;
  } catch (error) {
    const errorMsg = error?.response?.data || ERROR_MESSAGE;
    if (errorMsg === API_OFFLINE_ERROR) {
      toast.error(errorMsg, { toastId: API_TOAST_ID });
    }
    else {
      utils.execute510Handler(error, 'GET_WIFI_STATUS_ERROR');
    }
    dispatch({
      type: 'GET_WIFI_STATUS_ERROR',
      error,
    });
    return false;
  }
};

export const disableWifi = (token, vpn) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.boxes.disableWifi(vpn, checkIfIsBoxTab());
    if (typeof data === 'string') throw new Error(data);
    return data;
  } catch (error) {
    utils.execute510Handler(error, 'DISABLE_WIFI_ERROR');
    dispatch({
      type: 'DISABLE_WIFI_ERROR',
      error,
    });
    return false;
  }
};

export const enableWifi = (token, vpn, body) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.boxes.enableWifi(vpn, checkIfIsBoxTab(body));
    if (typeof data === 'string') throw new Error(data);
    return data;
  } catch (error) {
    utils.execute510Handler(error, 'ENABLE_WIFI_ERROR');
    dispatch({
      type: 'ENABLE_WIFI_ERROR',
      error,
    });
    toast.error(error?.response?.Error_Msg || ERROR_MESSAGE);
    return false;
  }
};

export const addBoxAction = (token, bid, body) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'ADD_BOX_ACTION',
    bid,
    body,
    token,
  });
  try {
    const data = await api.boxes.addBoxAction(bid, checkIfIsBoxTab(body));
    if (data.canOverride && !data.canOverride) {
      toast.error(
        `Another User already has this Device unlocked for editing. User ${data.user} is currently making changes. Please wait and try again later, or ask them to lock the device for changes.`,
      );
    }
    dispatch({
      type: 'ADD_BOX_ACTION_SUCCESS',
      data,
    });
  } catch (error) {
    dispatch({
      type: 'ADD_BOX_ACTION_ERROR',
      error,
    });
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'ADD_BOX_ACTION_ERROR',
    });
  }
};

export const activateE2 = (token, bid, body) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.boxes.activateE2(bid, checkIfIsBoxTab(body));
    dispatch({
      type: 'ACTIVATE_E2_SUCCESS',
      data,
    });
    toast.success('Edge Device Updated');
    return data; // Return data instead of true to allow checking for dot1x object
  } catch (error) {
    dispatch({
      type: 'ACTIVATE_E2_ERROR',
      error,
    });
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'ACTIVATE_E2_ERROR',
    });
    return false;
  }
};

export const deactivateE2 = (token, bid) => async dispatch => {
  const api = new Api(token);
  try {
    await api.boxes.deactivateE2(bid, checkIfIsBoxTab());
    toast.success('Edge Device Updated');
    return true;
  } catch (error) {
    dispatch({
      type: 'DEACTIVATE_E2_ERROR',
      error,
    });
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'DEACTIVATE_E2_ERROR',
    });
    return false;
  }
};

export const activateE3 = (token, bid) => async dispatch => {
  const api = new Api(token);
  try {
    await api.boxes.activateE3(bid, checkIfIsBoxTab());
    return true;
    toast.success('Edge Device Updated');
  } catch (error) {
    dispatch({
      type: 'DEACTIVATE_E3_ERROR',
      error,
    });
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'DEACTIVATE_E3_ERROR',
    });
  }
};
export const deactivateE3 = (token, bid) => async dispatch => {
  const api = new Api(token);
  try {
    await api.boxes.deactivateE3(bid, checkIfIsBoxTab());
    return true;
    toast.success('Edge Device Updated');
  } catch (error) {
    dispatch({
      type: 'DEACTIVATE_E3_ERROR',
      error,
    });
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'DEACTIVATE_E3_ERROR',
    });
    return false;
  }
};

export const getDhcp = (token, vpn) => async dispatch => {
  const api = new Api(token);
  try {
    const dhcpStatus = await api.boxes.getDhcp(vpn);
    return dhcpStatus?.Response;
  } catch (error) {
    const errorMsg = error?.response?.data || 'Wifi unavailable for this device';
    dispatch({
      type: 'DHCP_STATUS_ERROR',
      error: 'Wifi unavailable for this device',
    });
    if (errorMsg === API_OFFLINE_ERROR) {
      toast.error(errorMsg, { toastId: API_TOAST_ID });
    } else {
      toast.error('Wifi unavailable for this device', {
        toastId: 'DHCP_STATUS_ERROR',
      });
    }
    return false;
  }
};

export const getNetworkConnectivatyStatus = (token, bid) => async dispatch => {
  const api = new Api(token);
  try {
    const networkInfo = await api.boxes.getNetworkConnectivatyStatus(bid);
    if (networkInfo?.error) {
      // toast.info(networkInfo?.error);
      return false;
    }
    return networkInfo;
  } catch (error) {
    // Error Message from API
    const errorMsg = error?.response?.data || ERROR_MESSAGE;
    if (errorMsg === API_OFFLINE_ERROR) {
      toast.error(errorMsg, { toastId: API_TOAST_ID });
    }

    return errorMsg;
  }
};

export const disableDHCP = (token, vpn) => async dispatch => {
  const api = new Api(token);
  try {
    // eslint-disable-next-line no-shadow
    const disableDHCP = await api.boxes.disableDHCP(vpn, checkIfIsBoxTab());
    return disableDHCP?.Response;
  } catch (error) {
    dispatch({
      type: 'DISABLE_DHCP_ERROR',
      error,
    });
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'DISABLE_DHCP_ERROR',
    });
    return false;
  }
};

export const enableDHCP = (token, vpn) => async dispatch => {
  const api = new Api(token);
  try {
    // eslint-disable-next-line no-shadow
    const enableDHCP = await api.boxes.enableDHCP(vpn, checkIfIsBoxTab());
    return enableDHCP?.Response;
  } catch (error) {
    dispatch({
      type: 'ENABLE_DHCP_ERROR',
      error,
    });
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'ENABLE_DHCP_ERROR',
    });
    return false;
  }
};

export const disableRecording = (token, bid) => async dispatch => {
  const api = new Api(token);
  try {
    await api.boxes.disableRecording(bid, checkIfIsBoxTab());
    toast.success('Call recording disabled successfully.');
    return true;
  } catch (error) {
    dispatch({
      type: 'DISABLE_RECORDING_ERROR',
      error,
    });
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'DISABLE_RECORDING_ERROR',
    });
  }
  return false;
};

export const rebootObi = (token, deviceId) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.boxes.rebootObi(deviceId, checkIfIsBoxTab());
    dispatch({
      type: 'REBOOT_OBI_SUCCESS',
      data,
    });
    toast.success('Successfully rebooted');
    return true;
  } catch (error) {
    dispatch({
      type: 'REBOOT_OBI_ERROR',
      error,
    });
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'REBOOT_OBI_ERROR',
    });
    return false;
  }
};

export const failoverInstall = (token, bid, vpn) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.boxes.failoverInstall(bid, vpn);
    dispatch({
      type: 'FAILOVER_INSTALL_SUCCESS',
      data,
    });
    toast.success('Failover install queued successfully'); // failover success feedback
    return true;
  } catch (error) {
    dispatch({
      type: 'FAILOVER_INSTALL_ERROR',
      error,
    });
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'FAILOVER_INSTAL_ERROR',
    });
    return false;
  }
};

export const rebootEpikBox = (token, bid) => async dispatch => {
  const api = new Api(token);
  const { CancelToken } = axios;
  const source = CancelToken.source();
  setTimeout(() => {
    source.cancel('Device is in reboot state. Run EPIK Edge Address Ping test to verify.');
  }, 5000);

  dispatch({
    type: 'REBOOT_EPIK_BOX',
    bid,
    token,
  });
  const obj = {
    source,
    bid,
  };
  try {
    const data = await api.boxes.rebootEpikBox(obj, checkIfIsBoxTab());
    dispatch({
      type: 'REBOOT_EPIK_BOX_SUCCESS',
      data,
    });
    toast.success('Successfully rebooted Epik Edge Device');
    return true;
  } catch (error) {
    // Error Message from API
    if (axios.isCancel(error)) {
      toast.info('Device is in reboot state. Run EPIK Edge Address Ping test to verify.');
      return false;
    } else {
      utils.execute510Handler(error, 'REBOOT_EPIK_BOX_ERROR');
      dispatch({
        type: 'REBOOT_EPIK_BOX_ERROR',
        error,
      });
      return false;
    }
  }
};

export const applyUpdateEpikBox = (token, bid) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'APPLY_UPDATE_EPIK_BOX',
    bid,
    token,
  });
  try {
    const data = await api.boxes.applyUpdateEpikBox(bid, checkIfIsBoxTab());
    dispatch({
      type: 'APPLY_UPDATE_EPIK_BOX_SUCCESS',
      data,
    });
    toast.success('Successfully updated firmware on Epik Edge Device');
    return true;
  } catch (error) {
    dispatch({
      type: 'APPLY_UPDATE_EPIK_BOX_ERROR',
      error,
    });
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'APPLY_UPDATE_EPIK_BOX_ERROR',
    });
    return false;
  }
};

export const convertBoxDid = (token, bid, body) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'CONVERT_BOX_DID',
    bid,
    token,
  });
  try {
    await api.boxes.convertBoxDid(bid, checkIfIsBoxTab(body));
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'CONVERT_BOX_DID_ERROR',
    });
  }
};

export const getVoicePorts = (token, boxId) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.boxes.getVoicePorts(boxId);
    return data;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'GET_VOICE_PORTS_ERROR',
    });
  }
};
export const getModemPorts = (token, boxId) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.boxes.getModemPorts(boxId);
    return data;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'GET_MODEM_HUNT_PORTS_ERROR',
    });
  }
};

export const getAllPortsName = (token, boxId) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.boxes.getAllPortsName(boxId);
    return data;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'GET_VOICE_PORTS_ERROR',
    });
  }
};

export const setInterfacePriority = (token, vpn, priorityOfInterest,value) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.boxes.setInterfacePriority(vpn,priorityOfInterest, checkIfIsBoxTab(),value);
    toast.success('Interface priority changed successfully');
    return data;
  } catch (error) {
    // Error Message from API
    utils.execute510Handler(error, 'SET_INTERFACE_PRIORITY_ERROR');
  }
};
export const setInterfacePriorityIsp = (token, vpn, value) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.boxes.setInterfacePriorityIsp(vpn, value, checkIfIsBoxTab());
    toast.success('Interface priority changed successfully');
    return data;
  } catch (error) {
    // Error Message from API
    utils.execute510Handler(error, 'SET_INTERFACE_PRIORITY_ERROR');
  }
};

export const boxHardReset = (token, vpn, source) => async () => {
  const api = new Api(token);
  const object = {
    vpn,
    source,
  };
  try {
    await api.boxes.boxHardReset(object, checkIfIsBoxTab());
    toast.success('Device hard reset successful');
    return true;
  } catch (error) {
    if (axios.isCancel(error)) {
      return true;
    }
    utils.execute510Handler(error, 'BOX_HARD_RESET_ERROR');
    return false;
  }
};

export const getInterfacePriority = (token, vpn) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.boxes.getInterfacePriority(vpn);
    // console.info({new: data})
    return data;
  } catch (error) {
    const errorMsg = error?.response?.data || ERROR_MESSAGE;
    // Error Message from API
    if (errorMsg === API_OFFLINE_ERROR) {
      toast.error(errorMsg, { toastId: API_TOAST_ID });
    }
    else {
      utils.execute510Handler(error, 'GET_INTERFACE_PRIORITY_ERROR');
    }
    return false;
  }
};
export const getInterfacePriorityIsp = (token, vpn) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.boxes.getInterfacePriorityIsp(vpn);
    // console.info({new: data})
    return data;
  } catch (error) {
    const errorMsg = error?.response?.data || ERROR_MESSAGE;
    // Error Message from API
    if (errorMsg === API_OFFLINE_ERROR) {
      toast.error(errorMsg, { toastId: API_TOAST_ID });
    }
    else {
      utils.execute510Handler(error, 'GET_INTERFACE_PRIORITY_ERROR');
    }
    return false;
  }
};

export const setCarrier = (token, vpn, value) => async () => {
  const api = new Api(token);
  try {
    const data = await api.boxes.setCarrier(vpn, checkIfIsBoxTab(value));
    if (data.apnSet) {
      toast.success('APN updated successfully');
    } else {
      toast.error('Failed to update APN');
      return false;
    }
    return data;
  } catch (error) {
    const message_ = error?.response?.data || error?.response?.data?.message || ERROR_MESSAGE;
    if (message_ === API_OFFLINE_ERROR) {
      toast.error(message_, { toastId: API_TOAST_ID });
    }
    else {
      // Error Message from API
      utils.execute510Handler(error, 'SET_CARRIER_ERROR');
    }
    return false;
  }
};

export const getCarrier = (token, vpn, carrier) => async () => {
  const api = new Api(token);
  try {
    const data = await api.boxes.getCarrier(vpn, carrier);
    return data;
  } catch (error) {
    // Error Message from API
    const message_ = error?.response?.data || error?.response?.data?.message || ERROR_MESSAGE;
    if (message_ === API_OFFLINE_ERROR) {
      toast.error(message_, { toastId: API_TOAST_ID });
    }
    else {
      utils.execute510Handler(error, 'GET_CARRIER_ERROR');
    }
    return false;
  }
};

export const getCurrentApn = (token, vpn) => async () => {
  const api = new Api(token);
  try {
    const data = await api.boxes.getCurrentApn(vpn);
    return data;
  } catch (error) {
    // Error Message from API
    const message_ = error?.response?.data || error?.response?.data?.message || ERROR_MESSAGE;
    if (message_ === API_OFFLINE_ERROR) {
      toast.error(message_, { toastId: API_TOAST_ID });
    }
    else {
      utils.execute510Handler(error, 'GET_CURRENT_APN_ERROR');
    }
    return false;
  }
};

export const editOptionsChange = (name, value) => dispatch => {
  dispatch({
    type: 'EDIT_OPTIONS_CHANGE',
    name,
    value,
  });
};

export const isUpdatedRequired = (token, id) => async dispatch => {
  const api = new Api(token);
  try {
    const res = await api.boxes.isUpdateRequired(id);
    return res;
  } catch (error) {
    toast.error(error?.response?.data || ERROR_MESSAGE);
    return false;
  }
};

export const sipPriDiagnosticsPort = (token, object) => async dispatch => {
  const api = new Api(token);
  try {
    const res = await api.boxes.sipPriDiagnosticsPort(object);
    return res;
  } catch (error) {
    toast.error(error.response.data);
    return false;
  }
};

export const optionsBoxChange = boxData => dispatch => {
  dispatch({
    type: 'OPTIONS_BOX_CHANGE',
    boxData,
  });
};

export const editPriChange = (name, value) => dispatch => {
  dispatch({
    type: 'EDIT_PRI_CHANGE',
    name,
    value,
  });
};

export const priBoxChange = boxData => dispatch => {
  dispatch({
    type: 'PRI_BOX_CHANGE',
    boxData,
  });
};

export const updateEpikBoxObi = (token, obi, epikboxUser, numId) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'EPIK_BOX_OBI_UPDATE',
    obi,
  });
  try {
    const data = await api.boxes.updateObi(checkIfIsBoxTab(obi), epikboxUser, numId);
    dispatch({
      type: 'EPIK_BOX_OBI_UPDATE_SUCCESS',
      data,
    });
    // dispatch({
    //   type: 'UPDATE_BOX_ON_OBIS_UPDATE',
    //   obis: data.data,
    // });
    toast.success('EPI updated successfully', { toastId: 'EPIK_BOX_OBI_UPDATE_SUCCESS' });
    return true;
  } catch (error)
  {
    const errorMessage = error?.response?.data || ERROR_MESSAGE;
    const isEpiProvisioningDisabled = errorMessage.includes('failed to push config on cloud');
    toast.error(isEpiProvisioningDisabled ? 'EPI Provisioning is disabled' : (errorMessage || ERROR_MESSAGE), {
      toastId: 'EPIK_BOX_OBI_UPDATE_ERROR',
    });
    dispatch({
      type: 'EPIK_BOX_OBI_UPDATE_ERROR',
      error,
    });
    return false;
  }
};
export const updateNumbers = (token, obi, epikboxUser, numId,fieldToUpdate, value, showToast = true) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.boxes.updateNumbers(checkIfIsBoxTab(obi), epikboxUser, numId,fieldToUpdate, value);
    dispatch({
      type: 'EPIK_BOX_NUMBERS_DATA_UPDATE_SUCCESS',
      data,
    });
    if(showToast)
      toast.success('Port updated successfully', { toastId: 'EPIK_BOX_NUMBERS_DATA_SUCCESS' });
    return true;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || error?.message || ERROR_MESSAGE, {
      toastId: 'EPIK_BOX_NUMBERS_DATA_ERROR',
    });
    dispatch({
      type: 'EPIK_BOX_NUMBERS_DATA_ERROR',
      error,
    });
    return false;
  }
};

export const obiRebootRequired = (token, id, payload) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.boxes.obiRebootRequired(id, checkIfIsBoxTab(payload));
    dispatch({
      type: 'EPIK_BOX_OBI_UPDATE_SUCCESS',
      data,
    });
    toast.success('EPI updated successfully', { toastId: 'EPIK_BOX_OBI_UPDATE_SUCCESS' });
    return true;
  } catch (error) {
    toast.error(error?.response?.data || error?.message || ERROR_MESSAGE, {
      toastId: 'EPIK_BOX_OBI_UPDATE_ERROR',
    });
    return false;
  }
};

export const portConfig = (token, body) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.boxes.portConfig(checkIfIsBoxTab(body));
    dispatch({
      type: 'PORT_CONFIG_SUCCESS',
      data,
    });
    toast.success('Port configured successfully', { toastId: 'PORT_CONFIG_SUCCESS' });
    return true;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'PORT_CONFIG_ERROR',
    });
    dispatch({
      type: 'PORT_CONFIG_ERROR',
      error,
    });
    return false;
  }
};

export const getPortValues = (token, obiId, values) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.boxes.getPortValues(obiId, values);
    return data;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'GET_PORT_VALUES_ERROR',
    });
    dispatch({
      type: 'GET_PORT_VALUES_ERROR',
      error,
    });
    return false;
  }
};

export const setPortValues = (token, obiId, body) => async dispatch => {
  const api = new Api(token);
  try {
    const res = await api.boxes.setPortValues(obiId, checkIfIsBoxTab(body));
    toast.success('Port configuration updated');
    return res;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'SET_PORT_VALUES_ERROR',
    });
    dispatch({
      type: 'SET_PORT_VALUES_ERROR',
      error,
    });
    return false;
  }
};

export const setSilenceDetect = (token, obiId, portNum, toggle) => async dispatch => {
  const api = new Api(token);
  try {
    await api.boxes.setSilenceDetect(obiId, portNum, toggle);
    return true;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'SET_SILENCE_DETECT_ERROR',
    });
    dispatch({
      type: 'SET_SILENCE_DETECT_ERROR',
      error,
    });
    return false;
  }
};

export const unCheckPri = (token, bid) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'UN_CHECK_PRI',
    bid,
  });
  try {
    const data = await api.boxes.unCheckPri(bid, checkIfIsBoxTab());
    dispatch({
      type: 'UN_CHECK_PRI_SUCCESS',
      data,
    });
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'UN_CHECK_PRI_ERROR',
    });
    dispatch({
      type: 'UN_CHECK_PRI_ERROR',
      error,
    });
  }
};
export const advancedMonitoring = (token, body) => async dispatch => {
  const api = new Api(token);

  try {
    const data = await api.boxes.advancedMonitoring(checkIfIsBoxTab(body));
    dispatch({
      type: 'ADVANCE_MONITORING_SUCCESS',
      data,
    });
    const toggleStatus = body.toggle === true ? 'enabled' : 'disabled';
    toast.success(`Advance monitoring ${toggleStatus}`, { toastId: 'ADVANCE_MONITORING_SUCCESS' });
    return body.toggle;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'ADVANCE_MONITORING_ERROR',
    });
    dispatch({
      type: 'ADVANCE_MONITORING_ERROR',
      error,
    });
    return error;
  }
};

export const unassignNumber = (token, numId, port) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.boxes.unassignNumber(numId, checkIfIsBoxTab({ port }));
    dispatch({
      type: 'UNASSIGN_NUMBER_SUCCESS',
      data,
    });

    toast.success('Number unassigned successfully', { toastId: 'UNASSIGN_NUMBER_SUCCESS' });
    return true;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'UNASSIGN_NUMBER_ERROR',
    });
    dispatch({
      type: 'UNASSIGN_NUMBER_ERROR',
      error,
    });
    return false;
  }
};

export const uploadPortConfig = (token, obi, configFile) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'EPIK_BOX_OBI_CONFIG_UPLOAD',
    obi,
    configFile,
  });
  try {
    const data = await api.boxes.uploadConfig(obi, checkIfIsBoxTab(JSON.parse(configFile)));
    if (data.omitted && Object.keys(data.omitted).length) {
      toast.error(
        `The following items are not configurable\n${Object.keys(data.omitted).join(', ')}`,
        { toastId: 'EPIK_BOX_OBI_CONFIG_UPLOAD_ERROR' },
      );
    }
    dispatch({
      type: 'EPIK_BOX_OBI_CONFIG_UPLOAD_SUCCESS',
      data,
    });
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'EPIK_BOX_OBI_CONFIG_UPLOAD_ERROR',
    });
    dispatch({
      type: 'EPIK_BOX_OBI_CONFIG_UPLOAD_ERROR',
      error,
    });
  }
};

export const postBoxConfig = (token, obi, jsonObj) => async dispatch => {
  const api = new Api(token);
  try {
    await api.boxes.uploadConfig(obi, checkIfIsBoxTab(JSON.parse(jsonObj)));
    return true;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE);
    return false;
  }
};

export const downloadBoxConfig = (token, obi, configFile) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'EPIK_BOX_OBI_CONFIG_DOWNLOAD',
    obi,
    configFile,
  });
  try {
    const data = await api.boxes.downloadConfig(obi, configFile);
    dispatch({
      type: 'EPIK_BOX_OBI_CONFIG_DOWNLOAD_SUCCESS',
      data,
    });
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'EPIK_BOX_OBI_CONFIG_DOWNLOAD_ERROR',
    });
    dispatch({
      type: 'EPIK_BOX_OBI_CONFIG_DOWNLOAD_ERROR',
      error,
    });
  }
};

export const populateEpis = token => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'POPULATE_EPI',
  });
  try {
    // const data = await api.boxes.populateEpis();

    // toast.success(`${data} new EPIs added.`, {
    //   toastId: 'POPULATE_EPI_SUCCESS',
    // });
    dispatch(getUnassignedObis(token, { page: 1, limit: 20 }));
    dispatch({
      type: 'POPULATE_EPI_SUCCESS',
      data: {},
      // data,
    });
  } catch (error) {
    dispatch({
      type: 'POPULATE_EPI_ERROR',
      error,
    });
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'POPULATE_EPI_ERROR',
    });
  }
};

export const epikBoxesCompanyFilter = filter => dispatch => {
  dispatch({
    type: 'EPIK_BOXES_COMPANY_FILTER',
    filter,
  });
};

export const advanceLocalArray = filter => dispatch => {
  dispatch({
    type: 'ADVANCE_LOCAL_ARRAY',
    filter,
  });
};

export const getEpikBoxObis = (token, boxId, companyId) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'EPIK_BOX_OBIS',
    boxId,
    companyId,
  });
  try {
    const data = await api.boxes.getBoxObis(boxId, companyId);
    dispatch({
      type: 'EPIK_BOX_OBIS_SUCCESS',
      data,
    });
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'EPIK_BOX_OBIS_ERROR',
    });
    dispatch({
      type: 'EPIK_BOX_OBIS_ERROR',
      error,
    });
  }
};

export const getUnassignedObis = (token, paginateOptions, searchString) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'UNASSIGNED_OBIS',
  });
  try {
    const boxes = await api.boxes.getUnassignedObis(paginateOptions, searchString);
    dispatch({
      type: 'UNASSIGNED_OBIS_SUCCESS',
      boxes,
    });
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'UNASSIGNED_OBIS_ERROR',
    });
    dispatch({
      type: 'UNASSIGNED_OBIS_ERROR',
      error,
    });
  }
};

export const clearUnassignedObis = () => async dispatch => {
  dispatch({
    type: 'UNASSIGNED_OBIS_CLEAR',
  });
};

export const showDeleteEpikBoxEpi = obi => dispatch => {
  dispatch({
    type: 'DELETE_BOX_EPI_OPEN',
    obi,
  });
};

export const cancelDeleteEpikBoxEpi = () => dispatch => {
  dispatch({
    type: 'DELETE_BOX_EPI_CANCEL',
  });
};

export const showDeletePhone = () => dispatch => {
  dispatch({
    type: 'DELETE_PHONE_OPEN',
  });
};

export const cancelDeletePhone = () => dispatch => {
  dispatch({
    type: 'DELETE_PHONE_CANCEL',
  });
};

export const deleteEpikBoxEpi = (token, obi) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'DELETE_BOX_EPI',
    obi,
  });
  try {
    const data = await api.boxes.deleteBoxEpi(checkIfIsBoxTab(obi));
    dispatch({
      type: 'EPIK_BOX_EPI_DELETE_SUCCESS',
      data,
    });
    return true;
  } catch (error) {
    dispatch({
      type: 'EPIK_BOX_EPI_DELETE_ERROR',
      error,
    });
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'EPIK_BOX_EPI_DELETE_ERROR',
    });
    return false;
  }
};

export const assignObiToBox = (token, obi, box, company) => async dispatch => {
  const api = new Api(token);
  dispatch({ type: 'ASSIGN_OBI_TO_BOX', obi, box, company });
  try {
    const assigned = await api.boxes.assignToBox(
      obi,
      checkIfIsBoxTab({ boxId: box, company }, true),
    );
    dispatch({
      type: 'ASSIGN_OBI_TO_BOX_SUCCESS',
      assigned,
    });
    dispatch(clearUnassignedObis());
    return true;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'ASSIGN_OBI_TO_BOX_ERROR',
    });
    dispatch({
      type: 'ASSIGN_OBI_TO_BOX_ERROR',
      error,
    });
    return false;
  }
};

export const assignAta = (token, body, bid) => async dispatch => {
  const api = new Api(token);
  dispatch({ type: 'ASSIGN_ATA', body });
  try {
    const assignedAta = await api.boxes.assignAta(checkIfIsBoxTab(body), bid);
    dispatch({
      type: 'ASSIGN_ATA_SUCCESS',
      assignedAta,
    });
    return assignedAta;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'ASSIGN_ATA_ERROR',
    });
    dispatch({
      type: 'ASSIGN_ATA_ERROR',
      error,
    });
    return false;
  }
};

export const unAssignAta = (token, externalId) => async dispatch => {
  const api = new Api(token);
  dispatch({ type: 'UN_ASSIGN_ATA', body: {} });
  try {
    const unAssignedAta = await api.boxes.unAssignAta(checkIfIsBoxTab({}), externalId);
    dispatch({
      type: 'UN_ASSIGN_ATA_SUCCESS',
      unAssignedAta,
    });
    return unAssignedAta;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'UN_ASSIGN_ATA_ERROR',
    });
    dispatch({
      type: 'UN_ASSIGN_ATA_ERROR',
      error,
    });
    return false;
  }
};

export const setUnassignedMacFilter = searchString => async dispatch => {
  dispatch({
    type: 'UNASSIGNED_FILTER_CHANGE',
    searchString,
  });
};

export const setBoxDetailsData = (token, box) => async dispatch => {
  const api = new Api(token);
  try {
    const boxDetail = await api.boxes.getBoxDetail(box);
    dispatch({
      type: 'BOX_DETAILS_DATA',
      box: boxDetail,
    });
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'EPIK_BOXES_ERROR',
    });
    dispatch({
      type: 'EPIK_BOXES_ERROR',
      error,
    });
  }
};

export const selectBoxDetailsObi = obi => dispatch => {
  dispatch({
    type: 'BOX_DETAILS_SELECT_OBI',
    obi,
  });
};

export const clearBoxDetailsObi = () => dispatch => {
  dispatch({
    type: 'BOX_DETAILS_CLEAR_OBI_SELECT',
  });
};

export const clearBoxDetailsAta = () => dispatch => {
  dispatch({
    type: 'BOX_DETAILS_CLEAR_ATA_SELECT',
  });
};

export const selectBoxDetailsPort = port => dispatch => {
  dispatch({
    type: 'BOX_DETAILS_SELECT_PORT',
    port,
  });
};

export const setPortConfigChangesMade = (changesMade) => dispatch => {
  dispatch({
    type: 'SET_PORT_CONFIG_CHANGES_MADE',
    payload: changesMade,
  });
};

export const clearPortConfigChangesMade = () => dispatch => {
  dispatch({
    type: 'CLEAR_PORT_CONFIG_CHANGES_MADE',
  });
};

export const setPortConfigModalSource = (source) => dispatch => {
  dispatch({
    type: 'SET_PORT_CONFIG_MODAL_SOURCE',
    payload: source, // 'portConfigButton' or 'customButton'
  });
};

export const clearPortConfigModalSource = () => dispatch => {
  dispatch({
    type: 'CLEAR_PORT_CONFIG_MODAL_SOURCE',
  });
};

export const selectBoxDetailsAta = ata => dispatch => {
  dispatch({
    type: 'BOX_DETAILS_SELECT_ATA_PORT',
    ata,
  });
};

export const clearBoxDetailsAtaPort = () => dispatch => {
  dispatch({
    type: 'BOX_DETAILS_CLEAR_PORT_ATA_SELECT',
  });
};

export const clearBoxDetailsPort = () => dispatch => {
  dispatch({
    type: 'BOX_DETAILS_CLEAR_PORT_SELECT',
  });
};

export const openUnassignedObis = () => dispatch => {
  dispatch({
    type: 'UNASSIGNED_OBI_SHOW',
  });
  dispatch(clearUnassignedObis());
};

export const closeUnassignedObis = () => dispatch => {
  dispatch({
    type: 'UNASSIGNED_OBI_HIDE',
  });
  dispatch(clearUnassignedObis());
};

export const openBoxConfig = () => dispatch => {
  dispatch({
    type: 'BOX_CONFIG_SHOW',
  });
};

export const closeBoxConfig = () => dispatch => {
  dispatch({
    type: 'BOX_CONFIG_HIDE',
  });
};

export const setRearrangeEPIs = epis => dispatch => {
  dispatch({
    type: 'SET_REARRANGE_EPI',
    epis,
  });
};

export const cancelRearrangeEPIs = () => dispatch => {
  dispatch({
    type: 'CANCEL_REARRANGE_EPI',
  });
};

export const commitRearrangedEPIs = (token, rearrangedEpis, box) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'UPDATE_BOX_EPIS',
    epis: rearrangedEpis,
  });
  try {
    const changedBox = {
      ...{
        _id: box._id,
        assignedTo: box.assignedTo,
      },
      Obis: rearrangedEpis,
    };
    await api.boxes.updateBox(checkIfIsBoxTab(changedBox));
    dispatch({
      type: 'UPDATE_BOX_EPIS_SUCCESS',
    });
    // [Action]- Change
    dispatch(changeAction('EPIs repositioned'));
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'UPDATE_BOX_EPIS_ERROR',
    });
    dispatch({
      type: 'UPDATE_BOX_EPIS_ERROR',
      error,
    });
  }
};

export const updateBoxField = (name, value) => dispatch => {
  dispatch({
    type: 'UPDATE_FIELD_BOX',
    name,
    value,
  });
};

export const filterByStatus = status => dispatch => {
  dispatch({
    type: 'FILTER_COMPANY_STATUS',
    status,
  });
};

export const importEpikBox = (token, number) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'IMPORT_EPIK_BOX',
  });
  try {
    const box = await api.boxes.importEpikBox(number);
    dispatch({
      type: 'IMPORT_EPIK_BOX_SUCCESS',
      box,
    });
    toast.success('box imported successfully!');
    return true;
  } catch (error) {
    dispatch({
      type: 'IMPORT_EPIK_BOX_ERROR',
      error,
    });
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'IMPORT_EPIK_BOX_ERROR',
    });
    return false;
  }
};

export const secondaryTunnelStatus = (token, box) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.boxes.secondaryTunnelStatus(box);
    return data;
    // return !(data?.Response.includes('WG: 0') || data?.Response.includes('WG Disabled')); // Api got changed and we are getting undefined error on includes
  } catch (error) {
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'SWITCH_TOGGGLE',
    });
    return false;
  }
};

export const secondaryTunnel = (token, box, status) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.boxes.secondaryTunnel(box, status, checkIfIsBoxTab());
    // return data;
    // return !(data?.Response.includes('WG: 0') || data?.Response.includes('WG Disabled')); // Api got changed and we are getting undefined error on includes
    return { result: data, checks: true };
  } catch (error) {
    utils.execute510Handler(error, 'SET_SWITCH_TOGGGLE_ERROR');
    return { result: error, checks: false };
  }
};

export const getActiveInterface = (token, boxId, vpnAddress) => async dispatch => {
  const api = new Api(token);
  try {
    const interfaceValue = await api.boxes.getActiveInterface(boxId, vpnAddress);
    return interfaceValue;
  } catch (error) {
    utils.execute510Handler(error, 'GET_ACTIVE_INTERFACE_ERROR');
    dispatch({
      type: 'GET_ACTIVE_INTERFACE_ERROR',
      error,
    });
    return false;
  }
};

export const getPublicIP = (token, vpnAddress) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.boxes.getPublicIP(vpnAddress);
    if (data.failure || data == "") {
      return null;
    }else return data;
  } catch (error) {
    console.log('Error while getting public IP.');
    return false;
  }
};
export const getLanIP = (token, vpnAddress) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.boxes.getLanIP(vpnAddress);
    if (data.failure || data == "") {
      return null;
    } else return data;
  } catch (error) {
    console.log('Error while getting Lan IP.');
    return false;
  }
};
export const getFirmwareVersion = (token, bid) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.boxes.getFirmwareVersion(bid);
    dispatch({
      type: 'GET_FIRMWARE_VERSION',
      payload: data,
    });
    return data;
  } catch (error) {
    utils.execute510Handler(error, 'GET_FIRMWARE_VERSION');
    return false;
  }
};

export const getEpikBoxesByMacAddress = (
  token,
  macAddress,
  online,
  pagination,
) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'EPIK_BOXES_BY_MAC_ADDRESS',
  });
  try {
    const boxes = await api.boxes.getEpikBoxesByMacAddress(macAddress, online, pagination);
    const box = boxes;
    dispatch({
      type: 'EPIK_BOXES_SUCCESS',
      boxes: box,
    });
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'EPIK_BOXES_ERROR',
    });
    dispatch({
      type: 'EPIK_BOXES_ERROR',
      error,
    });
  }
};

export const getEpikBoxesByIMEI = (token, imei, online, pagination) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'EPIK_BOXES_BY_IMEI',
  });
  try {
    const boxes = await api.boxes.getEpikBoxesByIMEI(imei, online, pagination);
    dispatch({
      type: 'EPIK_BOXES_SUCCESS',
      boxes,
    });
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'EPIK_BOXES_ERROR',
    });
    dispatch({
      type: 'EPIK_BOXES_ERROR',
      error,
    });
  }
};

export const getEpikBoxesBySIM = (token, sim, online, pagination) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'EPIK_BOXES_BY_SIM',
  });
  try {
    const boxes = await api.boxes.getEpikBoxesBySIM(sim, online, pagination);
    dispatch({
      type: 'EPIK_BOXES_SUCCESS',
      boxes,
    });
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'EPIK_BOXES_ERROR',
    });
    dispatch({
      type: 'EPIK_BOXES_ERROR',
      error,
    });
  }
};

export const getEpikBoxesByCreated = (token, created, online, pagination) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'EPIK_BOXES_BY_CREATED',
  });
  try {
    const boxes = await api.boxes.getEpikBoxesByCreated(created, online, pagination);
    dispatch({
      type: 'EPIK_BOXES_SUCCESS',
      boxes,
    });
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'EPIK_BOXES_ERROR',
    });
    dispatch({
      type: 'EPIK_BOXES_ERROR',
      error,
    });
  }
};

export const updateFavoriteBox = (token, boxId) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'UPDATE_FAVORITE_BOX',
  });
  try {
    const boxes = await api.boxes.updateFavoriteBox(boxId);
    dispatch({
      type: 'UPDATE_FAVORITE_BOX_SUCCESS',
      boxes,
    });
    toast.success(
      'Box added to favorite successfully',
      { toastId: 'UPDATE_FAVORITE_BOX_SUCCESS' });
    return true;
  } catch (error) {
    dispatch({
      type: 'UPDATE_FAVORITE_BOX_ERROR',
      error,
    });
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'UPDATE_FAVORITE_BOX_ERROR',
    });
    return false;
  }
}

export const deleteFavoriteBox = (token, boxId) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'DELETE_FAVORITE_BOX',
  });

  try {
    const boxes = await api.boxes.deleteFavoriteBox(boxId);
    dispatch({
      type: 'DELETE_FAVORITE_BOX_SUCCESS',
      boxes,
    });
    toast.success(
      'Box removed from favorite successfully',
      { toastId: 'DELETE_FAVORITE_BOX_SUCCESS' });
    return true;
  }
  catch (error) {
    dispatch({
      type: 'DELETE_FAVORITE_BOX_ERROR',
      error,
    });
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'DELETE_FAVORITE_BOX_ERROR',
    });
    return false;
  }
}

export const getSimCheckUtilities = (token, boxId, vpnAddress) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_SIM_CHECK_UTILITIES',
  });
  try {
    const { data } = await api.boxes.getSimCheckUtilities(boxId, vpnAddress);
    if (!data || !data.simsCheck)
      toast.error(
        'Data not available or is currently being fetched. Please wait 5 minutes and try again.',
        {
          toastId: 'UPDATE_SIM_CHECK_UTILITIES_ERROR',
        },
      );
    dispatch({
      type: 'UPDATE_SIM_CHECK_UTILITIES_SUCCESS',
      data: data?.simsCheck || [],
    });
    return data?.simsCheck;
  } catch (error) {
    // Error Message from API
    if(error?.response?.data?.includes('status code 400')){
      toast.error('No Results Available to Display', {
        toastId: 'UPDATE_SIM_CHECK_UTILITIES_ERROR',
      });
    } else {
      toast.error(error?.response?.data || ERROR_MESSAGE, {
        toastId: 'UPDATE_SIM_CHECK_UTILITIES_ERROR',
      });
    }
    dispatch({
      type: 'UPDATE_SIM_CHECK_UTILITIES_ERROR',
      error,
    });
  }
};
export const getBoxConnectedUsbs = (token, boxId, vpnAddress) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_CONNECTED_USBS',
  });
  try {
    const { data } = await api.boxes.getBoxConnectedUsbs(boxId, vpnAddress, checkIfIsBoxTab());
    dispatch({
      type: 'GET_CONNECTED_USBS_SUCCESS',
    });
    return data;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'GET_CONNECTED_USBS_ERROR',
    });
    dispatch({
      type: 'GET_CONNECTED_USBS_ERROR',
      error,
    });
  }
};
export const runSimCheck = (token, boxId, vpnAddress) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'SIM_CHECK',
  });
  try {
    const { data } = await api.boxes.runSimCheck(boxId, vpnAddress, checkIfIsBoxTab());
    dispatch({
      type: 'SIM_CHECK_SUCCESS',
    });
    toast.success('Successfully executed SIMs check utility.', { toastId: 'SIM_CHECK_SUCCESS' });
    dispatch(changeAction('Sim check'));
    return data;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'SIM_CHECK_ERROR',
    });
    dispatch({
      type: 'SIM_CHECK_ERROR',
      error,
    });
  }
};
export const updateBoxModelNumber = (token, vpnAddress) => async dispatch => {
  const api = new Api(token);
  try {
    const { data } = await api.boxes.updateBoxModelNumber(vpnAddress);
    if( data ){
      toast.success('Edge Device Model numer updated Sucessfully');
      return data.response;
    }else{
      toast.error('Something went wrong while updating Model Number');
    }
  } catch (error) {
    toast.error('Something went wrong while updating Model Number');
  }
};

export const errorInSimActivationState = error => async dispatch => {
  dispatch({
    type: SIM_ACTIVATION.ERROR,
    payload: error,
  });
};

export const resetSimActivationState = () => async dispatch => {
  dispatch({
    type: SIM_ACTIVATION.RESET,
  });
};

export const setLoadingInSimActivationState = () => async dispatch => {
  dispatch({
    type: SIM_ACTIVATION.START_LOADING,
  });
};

export const updateSimActivationState = data => async dispatch => {
  dispatch({
    type: SIM_ACTIVATION.UPDATE,
    payload: data,
  });
};

export const runSimActivationCheck = (sims, token = utils.getAuthToken()) => async dispatch => {
  const api = new Api(token);
  dispatch(setLoadingInSimActivationState());
  try {
    const response = await api.boxes.runSimActivationCheck(checkIfIsBoxTab(sims));
    if (response) dispatch(updateSimActivationState(response));
  } catch (error) {
    dispatch(
      errorInSimActivationState(
        error?.response?.data || error?.response?.data?.message || ERROR_MESSAGE,
      ),
    );
  }
};

/* DATA CENTER LATENCY */
export const errorWhileFetchingDataCenterLatency = error => dispatch => {
  dispatch({
    type: eDataCenterStateAction.ERROR,
    payload: error,
  });
};

export const setLoadingForDataCenterLatency = () => dispatch => {
  dispatch({
    type: eDataCenterStateAction.LOADING,
  });
};

export const updateDataCenterLatency = data => dispatch => {
  dispatch({
    type: eDataCenterStateAction.UPDATE,
    payload: data,
  });
};

export const resetDataCenterLatency = () => dispatch => {
  dispatch({
    type: eDataCenterStateAction.RESET,
  });
};

export const fetchDataCenterLatency = (
  boxId,
  showAllToastersFlag = true,
  token = utils.getAuthToken(),
  type = DATA_LATENCY_TYPE.GET_LATENCY,
  ignoreInfoToasterFlag = false,
) => async dispatch => {
  const api = new Api(token);

  /* TOASTER MESSAGES */
  const DATA_LATENCY_API_MESSAGES = {
    INFO: 'Data Request Update has been sent. Please wait.',
    SUCCESS: 'Data Center Latency Fetched Successfully',
  };

  dispatch(setLoadingForDataCenterLatency());

  /* Only show info toaster if showAllToastersFlag = true, BY DEFAULT, showAllToastersFlag is true */
  if (!ignoreInfoToasterFlag && showAllToastersFlag) toast.info(DATA_LATENCY_API_MESSAGES.INFO);
  try {
    const response = await api.boxes.fetchDataCenterLatency(boxId, type);

    /* Update latency if it is fetch call otherwise keep spinning the loader */
    if (type === DATA_LATENCY_TYPE.GET_LATENCY) {
      dispatch(updateDataCenterLatency(response));
    }

    /* Show Custom message if fetch call is successful otherwise show message sent by server */
    if (showAllToastersFlag) {
      if (type === DATA_LATENCY_TYPE.GET_LATENCY) toast.success(DATA_LATENCY_API_MESSAGES.SUCCESS);
      else {
        toast.success(response);
      }
    }
    return response;
  } catch (error) {
    const message_ = error?.response?.data || error?.response?.data?.message || ERROR_MESSAGE;
    // Error Message from API
    if (message_ === API_OFFLINE_ERROR) {
      toast.update(API_TOAST_ID, {
        render: message_,
        type: toast.TYPE.ERROR,
      });
    } else {
      toast.error(message_);
    }
    if (type === DATA_LATENCY_TYPE.GET_LATENCY)
      dispatch(errorWhileFetchingDataCenterLatency(message_));
  }
};

/* Enable Disable Port */

export const enableDisablePort = (payload, token = utils.getAuthToken()) => async dispatch => {
  const { boxId, obiId, port, mode } = payload;
  const api = new Api(token);
  try {
    const { message, updatedTime } = await api.boxes.enableDisablePort(
      boxId,
      obiId,
      port,
      mode,
      checkIfIsBoxTab(),
    );
    toast.success(message);
    return updatedTime;
  } catch (error) {
    const message_ = error?.response?.data || error?.response?.data?.message || ERROR_MESSAGE;
    toast.error(message_);
    return false;
  }
};

/* Reset Box To Default Action */
const startLoadingResetBoxToDefault = () => dispatch =>
  dispatch({
    type: eResetBoxActions.LOADING_RESET_BOX_CHANGES,
  });

const dispatchErrorToResetBoxToDefault = error => dispatch =>
  dispatch({
    type: eResetBoxActions.ERROR_WHILE_RESETTING_BOX,
    payload: error,
  });

const dispatchValueToResetBoxToDefault = data => dispatch =>
  dispatch({
    type: eResetBoxActions.DISPATCH_RESET_BOX_CHANGES_INTO_BOX,
    payload: data,
  });

// eslint-disable-next-line consistent-return
export const resetBoxToDefaultAction = (
  boxID,
  noteType,
  token = utils.getAuthToken(),
) => async dispatch => {
  const api = new Api(token);
  const BOX_REST_SUCCESS = 'Box has been resetted Successfully';
  try {
    dispatch(startLoadingResetBoxToDefault());
    const isBoxTab = checkIfIsBoxTab();
    const data = await api.boxes.resetBoxToDefaultService(boxID, {
      noteType,
      ...isBoxTab,
    });
    dispatch(dispatchValueToResetBoxToDefault(data));
    toast.success(BOX_REST_SUCCESS);
    return data || true;
  } catch (error) {
    const message = utils.generateErrorMessage(error);
    toast.error(message);
    dispatch(dispatchErrorToResetBoxToDefault());
  }
};

/* Interface Priority => [ACTIONS] */
export const setInterfacePriorityState = payload => dispatch =>
  dispatch({
    type: eInterfacePriorty.SET_INTERFACE,
    payload,
  });

export const updateReleaseNotes = (token, body) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'UPDATE_ACTIVE_MAINTENANCE',
  });
  try {
    const { _id: noteID, ...payload } = body;
    const data = await api.boxes.updateReleaseNotes(noteID, payload);
    dispatch({
      type: 'SET_MAINTENANCE_NOTE_SEEN_SUCCESS',
      data,
    });
    toast.success('Success');
  } catch (error) {
    // Error Message from API
    const message_ = error?.response?.data || error?.response?.data?.message || ERROR_MESSAGE;
    if (message_ === API_OFFLINE_ERROR) {
      toast.error(message_, { toastId: API_TOAST_ID });
    }
    else {
      toast.error(error?.response?.data || ERROR_MESSAGE, {
        toastId: 'UPDATE_ACTIVE_MAINTENANCE_NOTES_ERROR',
      });
    }
    dispatch({
      type: 'GETUPDATE_ACTIVE_MAINTENANCE_NOTES_ERROR',
      error,
    });
  }
};

export const deleteReleaseNotes = (token, noteID) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'DELETE_ACTIVE_MAINTENANCE',
  });
  try {
    const data = await api.boxes.deleteReleaseNotes(noteID);
    toast.success('Success');
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'DELETE_ACTIVE_MAINTENANCE_NOTES_ERROR',
    });
    dispatch({
      type: 'DELETE_ACTIVE_MAINTENANCE_NOTES_ERROR',
      error,
    });
  }
};

export const fetchDiagnosticReport = (token, boxId) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.boxes.fetchDiagnosticReport(boxId);

    toast.success(`Box diagnostic report fetched successfully!`);
    return data;
  } catch (error) {
    const message_ =
      error?.response?.data?.Response ||
      error?.response?.data ||
      error?.response?.data?.message ||
      ERROR_MESSAGE;

    toast.error(message_);
    return false;
  }
};
export const downloadRecMenulogs = (token, boxId,command) => async dispatch => {
  const api = new Api(token);
  try {
    dispatch({ type: 'DOWNLOAD_REC_LOGS' });
    const data = await api.boxes.downloadRecMenulogsService(boxId,command);
       dispatch({
         type: 'DOWNLOAD_REC_LOGS_SUCCESS',
         payload: data,
       });
    return data;
  } catch (error) {
    dispatch({
      type: 'DOWNLOAD_REC_LOGS_FAIL',
      error: error.message,
    });
  }
};

export const refreshDiagnosticResults = (token, boxId) => async dispatch => {
  const api = new Api(token);
  try {
    const { Response } = await api.boxes.refreshDiagnosticResults(boxId);
    toast.success(Response);
    return Response;
  } catch (error) {
    const message_ =
      error?.message || error?.response?.data || error?.response?.data?.message || ERROR_MESSAGE;
    toast.error(message_);
    return false;
  }
};

export const checkWatchguardIsActive = (token, boxId) => async dispatch => {
  const api = new Api(token);
  try {
    const { stdout } = await api.boxes.checkWatchguardIsActive(boxId);
    // toast.success(Response);
    return stdout;
  } catch (error) {
    const message_ =
      error?.message || error?.response?.data || error?.response?.data?.message || ERROR_MESSAGE;
    toast.error(message_);
    return message_;
  }
};

export const restartWatchguard = (token, boxId) => async dispatch => {
  const api = new Api(token);
  try {
    await api.boxes.restartWatchguard(boxId);
    toast.success(`Diagnostics service has been restarted successfully!`);
    return true;
  } catch (error) {
    const message_ =
      error?.message || error?.response?.data || error?.response?.data?.message || ERROR_MESSAGE;
    toast.error(message_);
    return false;
  }
};

export const getBoxVtelCdrs = (token, boxId) => async dispatch => {
  const api = new Api(token);
  try {
    const response = await api.boxes.getBoxVtelCdrs(boxId);
    return response;
  } catch (error) {
    const message_ =
      error?.response?.data || error?.message || error?.response?.data?.message || ERROR_MESSAGE;
    toast.error(message_);
    return false;
  }
};

export const getBoxVoipmonActivity = (token, boxID, payload) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.boxes.getBoxVoipmonActivity(boxID, payload);
    dispatch({
      type: 'GET_VOIPMON_ACTIVITY_SUCCESS',
      data: data || {},
    });
    toast.info(
      `${data?.total === 0 ? 'No activity logs found!' : 'CDR activity logs fetched successfully!'
      }`,
    );
    return data;
  } catch (error) {
    const message_ =
      error?.response?.data || error?.message || error?.response?.data?.message || ERROR_MESSAGE;
    toast.error(message_);
    return false;
  }
};

export const getAnalayticsImage = (token, boxId, callID,dataCenter) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.boxes.getAnalayticsImage(boxId, callID,dataCenter);
    return data;
  } catch (error) {
    toast.error('Cannot Find Call Flow Diagram.');
    return false;
  }
};

export const downloadAnalayticsFile = (token, boxId, callID) => async dispatch => {
  const api = new Api(token);
  try {
    const response = await api.boxes.downloadAnalayticsFile(boxId, callID);
    if (response.data) {
      const url = window.URL.createObjectURL(
        new Blob([response.data], {
          type: 'application/octet-stream',
        })
      );
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Analytics-CDR.pcap');
      document.body.appendChild(link);
      link.click();
      link.remove();
    } else {
      toast.error('Cannot Find PCAP File.')
    }
  } catch (error) {
    toast.error('Cannot Find PCAP File.')
    return false;
  }
};

export const removeAlarmProtocolSettings = (token, boxId, payload) => async dispatch => {
  const api = new Api(token);
  try {
    await api.boxes.removeAlarmProtocolSettings(token, boxId, payload);
    toast.success(`APR Settings removed.`);
    dispatch({
      type: 'UPDATE_ALARM_PROTOCOL_SUCCESS',
      updateAlarmProtocol: {},
    });
    return true;
  } catch (error) {
    const message_ = error?.response?.data || error?.response?.data?.message || ERROR_MESSAGE;
    toast.error(message_);
    return false;
  }
};

export const portChecklist = (token, bid, portType, portNumber) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_PORT_ACTIVATE_CHECKLIST',
  });
  try {
    const portChecklist = await api.boxes.portChecklist(bid, portType, portNumber);
    dispatch({
      type: 'GET_PORT_ACTIVATE_CHECKLIST_SUCCESS',
      portActivateChecklist: portChecklist,
    });
    return portChecklist;
  } catch (error) {
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'GET_PORT_ACTIVATE_CHECKLIST_ERROR',
    });
    return false;
  }
};

export const saveCheckList = (token, bid, body) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'POST_PORT_ACTIVATE_CHECKLIST',
  });
  try {
    const saveCheckList = await api.boxes.saveCheckList(bid, checkIfIsBoxTab(body));
    dispatch({
      type: 'POST_PORT_ACTIVATE_CHECKLIST_SUCCESS',
      portActivateChecklist: saveCheckList,
    });
    return saveCheckList;
  } catch (error) {
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'POST_PORT_ACTIVATE_CHECKLIST_ERROR',
    });
    return false;
  }
};

export const updateAdvanceModemConfigurations = (token, boxId, payload) => async dispatch => {
  const api = new Api(token);
  try {
    const result = await api.boxes.updateAdvanceModemConfigurations(boxId, payload);
    toast.success(result);
    dispatch({
      type: 'ADV_MODEM_CONFIG',
      value: payload.mode,
    });
    return true;
  } catch (error) {
    const message_ = error?.response?.data || error?.response?.data?.message || ERROR_MESSAGE;
    toast.error(message_);
    return false;
  }
};

export const getEpikBoxesGeoLocation = (token, boxId) => async dispatch => {
  const api = new Api(token);
  try {
    const result = await api.boxes.getEpikBoxesGeoLocation(boxId);
    return result;
  } catch (error) {
    const message_ =
      error.response.data.Response ||
      error.response.data.response ||
      error?.response?.data?.message ||
      error?.response?.data ||
      ERROR_MESSAGE;
    toast.error(message_);
    return false;
  }
};

export const getSelectedPortModal = type => async dispatch => {
  try {
    dispatch({
      type: 'GET_SELECTED_PORT_MODAL_TYPE_SUCCESS',
      modalType: type,
    });
  } catch (error) {
    dispatch({
      type: 'GET_SELECTED_PORT_MODAL_TYPE_ERROR',
      error: null,
    });
  }
};

export const triggerConnectivityStats = (token, boxId) => async dispatch => {
  const api = new Api(token);
  try {
    const result = await api.boxes.triggerConnectivityStats(boxId);
    toast.success(result?.response);
  } catch (error) {
    const message_ =
      error?.response?.data?.error ||
      error?.response?.data?.response ||
      error?.response?.data?.message ||
      error?.response?.data ||
      ERROR_MESSAGE;
    toast.error(message_);
    return false;
  }
};

export const exportBoxNotes = (token, boxId, queryFilter) => async dispatch => {
  const api = new Api(token);
  try {
    const result = await api.boxes.exportBoxNotes(boxId, queryFilter);
    return result;
  } catch (error) {
    const message_ = error?.message || ERROR_MESSAGE;
    toast.error(message_);
    return false;
  }
};

export const send2FA = (token, params) => async dispatch => {
  const api = new Api(token);
  try {
    const { isBoxTab } = checkIfIsBoxTab()
    const response = await api.boxes.sendFA(params, isBoxTab);
    toast.success('2FA code sent');
    return response;
  } catch (error) {
    const message_ =
      error?.response?.data || error?.message || error?.response?.data?.message || ERROR_MESSAGE;
    toast.error(message_);
    return false;
  }
};

export const authenticate2FA = (token, params) => async dispatch => {
  const api = new Api(token);
  try {
    const response = await api.boxes.authenticate2FA(params);
    toast.success('Your code is validated ');
    return response;
  } catch (error) {
    const message_ =
      error?.response?.data || error?.message || error?.response?.data?.message || ERROR_MESSAGE;
    toast.error(message_);
    return false;
  }
};

export const setMaintenanceNoteSeen = (token, activeNotificationsIds) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.boxes.setMaintenanceNoteSeen(activeNotificationsIds);
    return data;
  } catch (error) {
    return error?.message;
  }
};

export const boxActiveSimStats = (token, boxId) => async dispatch => {
  const api = new Api(token);
  try {
    const result = await api.boxes.boxActiveSimStats(boxId);
    return result;
  } catch (error) {
    const message_ = error?.response?.data;
    if (message_ === API_OFFLINE_ERROR) {
      toast.error(message_, { toastId: API_TOAST_ID });
    }
    else {
      toast.error(message_);
    }
    return false;
  }
};

export const addNewMacAddress = (token, macAddress) => async dispatch => {
  const api = new Api(token);
  try {
    const result = await api.boxes.addNewMacAddress(macAddress, checkIfIsBoxTab());
    toast.success(`MAC address added sucessfully`);
    return result;
  } catch (err) {
    const message_ = err?.response?.data || err.message || ERROR_MESSAGE;
    toast.error(message_);
    return false;
  }
};

export const end2FASession = (token, params) => async dispatch => {
  const api = new Api(token);
  try {
    const response = await api.boxes.end2FASession(params);
    return response;
  } catch (error) {
    const message_ =
      error?.response?.data || error?.message || error?.response?.data?.message || ERROR_MESSAGE;
    toast.error(message_);
    return false;
  }
};

export const getDataOnBoxLoad = (token, boxID) => async dispatch => {
  const api = new Api(token);
  try {
    const response = await api.boxes.getDataOnBoxLoad(boxID);

    if (response.failure) {

      dispatch(getSipPri(token, boxID, true));
      dispatch(getSipPri(token, boxID, false));

      if (response.boxData && response.boxData._id) {
        dispatch(updateBoxData(response.boxData));
      }

      return response;
    }

    const { boxPowerSource, boxSimStatus, boxData, boxAlarmStatus, boxDCAvgLatency, boxSipNumbers, boxPriNumbers, boxLteSignalStrength } = response
    delete boxLteSignalStrength.Error;

    dispatch(updateBoxData(boxData));

    if (boxPowerSource && !boxPowerSource.failure) {
      dispatch({
        type: 'EPIK_BOX_POWER',
        boxPower: boxPowerSource
      });
    }

    if (boxSimStatus && !boxSimStatus.failure) {
      dispatch({
        type: 'ESIM_STATUS_SUCCESS',
        data: boxSimStatus,
      });
    }

    if (boxDCAvgLatency && !boxDCAvgLatency.failure) {
      dispatch(updateDataCenterLatency(boxDCAvgLatency))
    }

    if (boxLteSignalStrength && !boxLteSignalStrength.failure) {
      dispatch({
        type: 'EPIK_BOX_SINGNAL_SUCCESS',
        signal: boxLteSignalStrength,
      });
    }

    dispatch({
      type: 'SET_PRI_DATA_SUCCESS',
      priSettings: boxPriNumbers?.priSettings,
    });

    dispatch({
      type: 'SET_SIP_DATA_SUCCESS',
      sipSettings: boxSipNumbers?.sipSettings,
    });

    dispatch(InitiateAlarm((boxAlarmStatus && boxAlarmStatus.remainingTime) || 0));

    return response;
  } catch (error) {
    return {
      failure: true
    };
  }
}

export const getIsBoxOnline = (token, vpnAddress) => async dispatch => {
  const api = new Api(token);
  try {
    const response = await api.boxes.getIsBoxOnline(vpnAddress);
    if (!response.success) {
      return response;
    }

    return response;
  } catch (error) {
    utils.objectErrorHandler(error);
    return false;
  }
}

export const sendBoxTone = (token, vpnAddress) => async dispatch => {
  const api = new Api(token);
  try {
    const response = await api.boxes.sendBoxTone(vpnAddress);
    toast.success('Beep sent to box');
    return response;
  } catch (error) {
    const message_ =
      error?.response?.data || error?.message || error?.response?.data?.message || ERROR_MESSAGE;
    toast.error(typeof message_ === 'object' ? message_[`${Object.keys(message_)[0]}`] : message_);
    return false;
  }
};


export const fetchAndAssignUsbs = (token, boxId, isBoxTabLock) => async dispatch => {
  const api = new Api(token);
  try {
    if (isBoxTabLock) {
      const { isBoxTab } = checkIfIsBoxTab();
      isBoxTabLock = isBoxTab
    }

    const response = await api.boxes.fetchAndAssignUsbs(isBoxTabLock, boxId);

    dispatch({
      type: 'OOB_SUCCESS',
      data: response.response
    })
    if (response.OOBM) {
      toast.success('OOBM enabled successfully ');
      return true;
    }
    return false; //return list of assignedUSBs
  } catch (error) {
    const message_ =
      error?.response?.data || error?.message || error?.response?.data?.message || ERROR_MESSAGE;
    toast.error(message_);
    return false;
  }
};

export const fetchTtyData = (token, boxId) => async dispatch => {
  const api = new Api(token);
  try {
    const response = await api.boxes.fetchTtyData(boxId);
    dispatch({
      type: 'TTY_DATA_SUCCESS',
      data: response
    })
    return response;
  } catch (error) {
    dispatch({
      type: 'TTY_DATA_ERROR',
      error
    })
    const message_ =
      error?.response?.data || error?.message || error?.response?.data?.message || ERROR_MESSAGE;
    toast.error(message_);
    return false;
  }
};

export const fetchAvailableOobBTNs = (token, boxId) => async dispatch => {
  const api = new Api(token);
  try {
    const response = await api.boxes.fetchAvailableOobBTNs(boxId);
    dispatch({
      type: 'OOB_ORDER_BTN_SUCCESS',
      data: response
    })
    return response;
  } catch (error) {
    dispatch({
      type: 'TTY_DATA_ERROR',
      error
    })
    const message_ =
      error?.response?.data || error?.message || error?.response?.data?.message || ERROR_MESSAGE;
    toast.error(message_);
    return false;
  }
};

export const postTtyData = (token, boxId, payload) => async dispatch => {
  const api = new Api(token);
  try {
    const { isBoxTab } = checkIfIsBoxTab()
    const response = await api.boxes.postTtyData(isBoxTab, boxId, payload);
    toast.success('TTY data saved successfully');
    return response;
  } catch (error) {
    dispatch({
      type: 'TTY_DATA_POST_ERROR',
      error
    })
    const message_ =
      error?.response?.data || error?.message || error?.response?.data?.message || ERROR_MESSAGE;
    toast.error(message_);
    return false;
  }
}

export const downloadTtyProfile = (token, boxId) => async dispatch => {
  const api = new Api(token);
  try {
    const response = await api.boxes.downloadTtyProfile(boxId);
    console.log("Dowbload Response ::", response);
    const link = document.createElement('a');
    link.href = response;
    link.setAttribute('download', 'TTY_Profile.ovpn');
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    dispatch({
      type: 'TTY_DATA_POST_ERROR',
      error
    })
    const message_ =
      error?.response?.data || error?.message || error?.response?.data?.message || ERROR_MESSAGE;
    toast.error(message_);
    return false;
  }
}

export const createSshUserProfile = (token, boxId, payload) => async dispatch => {
  const api = new Api(token);
  const { isBoxTab } = checkIfIsBoxTab()

  try {
    const { response } = await api.boxes.createSshUserProfile(isBoxTab, boxId, payload);
    toast.success(response || 'success');
    return response;
  } catch (error) {
    const message_ =
      error?.response?.data || error?.message || error?.response?.data?.message || ERROR_MESSAGE;
    toast.error(message_);
    return false;
  }
}

export const manageOpenVpnProfile = (token, boxId, ttyToggle) => async dispatch => {
  const api = new Api(token);
  const { isBoxTab } = checkIfIsBoxTab()

  try {
    const response = await api.boxes.manageOpenVpnProfile(isBoxTab, boxId, ttyToggle);
    toast.success(`OpenVpn Profile ${ttyToggle ? 'created' : 'deleted'} successfully`);
    return response;
  } catch (error) {
    const message_ =
      error?.response?.data || error?.message || error?.response?.data?.message || ERROR_MESSAGE;
    toast.error(message_);
    return false;
  }
}

export const removeOob = (token, boxId) => async dispatch => {
  const api = new Api(token);
  const { isBoxTab } = checkIfIsBoxTab()
  try {
    const response = await api.boxes.removeOob(isBoxTab, boxId);
    toast.success('OOB disabled ');
    dispatch({
      type: 'OOB_SUCCESS',
      data: []
    })
    return response;
  } catch (error) {
    const message_ =
      error?.response?.data || error?.message || error?.response?.data?.message || ERROR_MESSAGE;
    toast.error(message_);
    return {
      failure: true
    };
  }
}

export const updateOOBDetail = () => async dispatch => {
  try {
    dispatch({
      type: 'OOB_UPDATE',
    })
  } catch (error) {
    const message_ =
      error?.response?.data || error?.message || error?.response?.data?.message || ERROR_MESSAGE;
    toast.error(message_);
    return false;
  }
};

export const updateAssignedUsbsName = (token, boxId, data,) => async dispatch => {
  const api = new Api(token);
  try {
    const { isBoxTab } = checkIfIsBoxTab();
    const response = await api.boxes.updateAssignedUsbsName(boxId, data, isBoxTab);
    dispatch({
      type: 'OOB_SUCCESS',
      data: response.response
    })
    toast.success('USBs are updated')
    return true;
  } catch (error) {
    const message_ =
      error?.response?.data || error?.message || error?.response?.data?.message || ERROR_MESSAGE;
    toast.error(message_);
    return false;
  }
}

export const latestMaintenanceNote = token => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.boxes.latestMaintenanceNote();
    return data;
  } catch (error) {
    return false;
  }
};

export const addOobCategory = (token, boxId, params,) => async dispatch => {
  const api = new Api(token);
  try {
    const { isBoxTab } = checkIfIsBoxTab();
    const response = await api.boxes.addOobCategory(boxId, params, isBoxTab);
    dispatch({
      type: 'OOB_CATEGORY_SUCCESS',
      data: response
    })
    return response;
  } catch (error) {
    const message_ =
      error?.response?.data || error?.message || error?.response?.data?.message || ERROR_MESSAGE;
    toast.error(message_);
    return false;
  }
}

export const getOobCategoryList = (token, boxId, company,) => async dispatch => {
  const api = new Api(token);
  try {
    const response = await api.boxes.getOobCategoryList(boxId, company);
    dispatch({
      type: 'FETCH_OOB_CATEGORY_SUCCESS',
      data: response
    })
    return response;
  } catch (error) {
    const message_ =
      error?.response?.data || error?.message || error?.response?.data?.message || ERROR_MESSAGE;
    // toast.error(message_);
    return false;
  }
}

export const getBoxVoltage = (token, vpnAddress) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.boxes.getBoxVoltage(vpnAddress);
    return data;
  } catch (error) {
    // Error Message from API
    utils.objectErrorHandler(error);
    return false;
  }
};

export const saveCurrentBoxData = box => async dispatch => {
  dispatch({
    type: 'EPIK_BOX_SMART',
    box,
  });
};
export const updateEpisFirmware = (token, boxId) => async dispatch => {
  const api = new Api(token);
  try {
    const { response } = await api.boxes.updateEpisFirmware(boxId);
    toast.success(response);
    return response;
  } catch (error) {
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'EPIK_BOXES_ERROR',
    });

    return false;
  }
}
export const updateAllEpisFirmware = (token, boxId) => async dispatch => {
  const api = new Api(token);
  try {
    const { response } = await api.boxes.updateAllEpisFirmware(boxId);
    toast.success(response);
    return response;
  } catch (error) {
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'EPIK_BOXES_ERROR',
    });

    return false;
  }
}

export const updateEpisFirmwareManually = (token, boxId, macAddress) => async dispatch => {
  const api = new Api(token);
  try {
    const { isBoxTab } = checkIfIsBoxTab();
    const { response } = await api.boxes.updateEpisFirmwareManually(boxId, macAddress, isBoxTab);
    toast.success(response);
    return response;
  } catch (error) {
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'EPIK_BOXES_ERROR',
    });
    return false;
  }
}
export const updateVad = (token, obiId, enable, noReboot) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.boxes.updateVad(obiId, enable, noReboot);
    return data;
  } catch (error) {
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'EPIK_BOXES_ERROR',
    });
    return false;
  }
}

export const provisionNow = (token, boxId,  macAddress) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.boxes.provisionNow(boxId, macAddress);
    return data;
  } catch (error) {
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'EPIK_BOXES_ERROR',
    });
    return false;
  }
}


export const ext_9override = (token, vpnAddress, extValue) => async dispatch => {
  const api = new Api(token);
  try {
    const response = await api.boxes.ext_9override(vpnAddress, extValue);
    dispatch({
      type: 'EXT_9OVERRIDE',
    })
    if (response?.error) {
      toast.error(response.error)
      return false
    } else {
      toast.success("Omit leading '9' override successfully  ");

    }
    return response;
  } catch (error) {
    utils.objectErrorHandler(error);
    return false;
  }
}


export const fetchNetworkInfo = (token, vpnAddress) => async dispatch => {
  const api = new Api(token);
  try {
    const response = await api.boxes.fetchNetworkInfo(vpnAddress);
    dispatch({
      type: 'NETWORK_INFO_UPDATE', payload: response?.networkInterfaceInfo
    })
    return response;
  } catch (error) {
    utils.objectErrorHandler(error);
    return false;
  }
}

export const refreshDhcp = (token, vpnAddress) => async dispatch => {
  const api = new Api(token);
  try {
    const response = await api.boxes.refreshDhcp(vpnAddress);
    if (response?.error) {
      toast.error(response.error)
      return false
    } else {
      toast.success(response?.response);

    }
    return response;
  } catch (error) {
    toast.error(error?.message)
    return false;
  }
};

export const enableDisableEth3 = (token, boxId, vpnAddress, eth3Value) => async dispatch => {
  const api = new Api(token);
  try {
    const { isBoxTab } = checkIfIsBoxTab();
    const response = await api.boxes.enableDisableEth3(boxId, vpnAddress, eth3Value, isBoxTab);
    dispatch({
      type: 'HANDLE_ETH03',
      payload: { eth3Disable: response.eth3Disable }
    })
    if (response?.error) {
      toast.error(response.error)
      return false
    } else {
      toast.success("Eth0/3 updated successfully  ");

    }
    return response;
  } catch (error) {
    let message_ =
      error?.response?.data || error?.message || error?.response?.data?.message || ERROR_MESSAGE;
    console.log("typeof ", typeof message_, message_[`${Object.keys(message_)[0]}`])
    message_ = typeof message_ == 'object' ? message_[`${Object.keys(message_)[0]}`] : message_
    toast.error(message_);
    return false;
  }
}
export const enableDisableEpikUpdates = (token, boxId, status) => async dispatch => {
  const api = new Api(token);
  try {
    const { isBoxTab } = checkIfIsBoxTab();
    const response = await api.boxes.enableDisableEpikUpdates(status, boxId, isBoxTab);
    toast.success(response);
    return response;
  } catch (error) {
    const message_ = error?.response?.data || error?.response?.data?.message || ERROR_MESSAGE;
    if (message_ === API_OFFLINE_ERROR) {
      toast.error(message_, { toastId: API_TOAST_ID });
    }
    else {
      toast.error(error?.response?.data || ERROR_MESSAGE, {
        toastId: 'EPIK_BOXES_ERROR',
      });
    }
    return false;
  }
}

export const fetchEpikUpdatesStatus = (token, boxId) => async dispatch => {
  const api = new Api(token);
  try {
    const response = await api.boxes.fetchEpikUpdatesStatus(boxId);
    return response;
  } catch (error) {
    toast.error(error?.response?.data?.code || ERROR_MESSAGE, {
      toastId: 'EPIK_BOXES_ERROR',
    });
    return false;
  }
}

export const updateDbcaAlert = (token, boxId, dbcaValue) => async dispatch => {
  const api = new Api(token);
  try {
    const { isBoxTab } = checkIfIsBoxTab();
    const response = await api.boxes.updateDbcaAlert(boxId, dbcaValue, isBoxTab);
    toast.success(response ? `DBCA alerts updated` : `DBCA alerts NOT updated`);
    return response;
  } catch (error) {
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'EPIK_BOXES_ERROR',
    });
    return false;
  }
}

export const getSetFavoriteBox = (boxes) => dispatch => {
  dispatch({
    type: 'GET_SET_FAVORITE',
    boxes
  });
};

export const startPcap = (deviceIP, epiIP, token) => async dispatch => {
  const api = new Api(token);

  const maxRetries = 3;
  const retryDelay = 2000;
  let attempt = 0;

  while (attempt < maxRetries) {
    try {

      const response = await api.boxes.startPcap(deviceIP, epiIP);

      dispatch({
        type: 'START_PCAP_SUCCESS',
        data: response,
      });

      return response;
    } catch (error) {
      attempt += 1;

      if (attempt >= maxRetries) {

        return dispatch({
          type: 'START_PCAP_ERROR',
          error,
        });
      }

      console.error(`Attempt ${attempt} failed: ${error.message}. Retrying in ${retryDelay / 1000}s...`);
      await new Promise((resolve) => setTimeout(resolve, retryDelay));
    }
  }
};

export const stopPcap = (deviceIP, epiIP, token) => async dispatch => {
  const api = new Api(token);

  const maxRetries = 3;
  const retryDelay = 2000;
  let attempt = 0;

  while (attempt < maxRetries) {
    try {
      const response = await api.boxes.stopPcap(deviceIP, epiIP);

      dispatch({
        type: 'STOP_PCAP_SUCCESS',
        data: response,
      });

      return response;
    } catch (error) {
      attempt += 1;

      if (attempt >= maxRetries) {

        return dispatch({
          type: 'STOP_PCAP_ERROR',
          error,
        });
      }

      console.error(`Attempt ${attempt} failed: ${error.message}. Retrying in ${retryDelay / 1000}s...`);
      await new Promise((resolve) => setTimeout(resolve, retryDelay));
    }
  }
};

export const downloadPcap = (deviceIP, epiIP, serialNum, token) => async dispatch => {
  const api = new Api(token);
  try {
    const response = await api.boxes.downloadPcap(deviceIP, epiIP, serialNum);
    const { blob, fileName } = response;

    if (blob) {
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      alert("Failed to download the file. Please contact the administrators.");
    }


    dispatch({
      type: 'DOWNLOAD_PCAP_SUCCESS',
      data: response,
    });

    return response;
  } catch (error) {

    dispatch({
      type: 'DOWNLOAD_PCAP_ERROR',
      error,
    });
    throw error;
  }
};
export const orderNewBTNs = (token, boxId, btnCount) => async dispatch => {
  const api = new Api(token);
  try {
    const { isBoxTab } = checkIfIsBoxTab();
    const response = await api.boxes.orderNewBTNs(boxId, btnCount, isBoxTab);
    // dispatch({
    //   type: 'OOB_ORDER_BTN_SUCCESS',
    //   data: response
    // })
    toast.success(`BTN ordered successfully.`)
    return response;
  } catch (error) {
    const message_ =
      error?.response?.data || error?.message || error?.response?.data?.message || ERROR_MESSAGE;
    toast.error(message_);
    console.log(error);
    console.log(message_);
    
    return false;
  }
}
export const GeocodeRequest = (token, addressData) => async dispatch => {
  const api = new Api(token);
  try {
    const response = await api.boxes.GeocodeRequestApi(addressData);
    // dispatch({
    //   type: 'OOB_ORDER_BTN_SUCCESS',
    //   data: response
    // })
    // toast.success(`BTN ordered successfully.`)
    return response;
  } catch (error) {
    const message_ =
      error?.response?.data || error?.message || error?.response?.data?.message || ERROR_MESSAGE;
    toast.error(message_);
    console.log(error);
    console.log(message_);
    return false;
  }
}
export const setTestStatusAlaram = (status) => ({
  type: 'SET_TEST_STATUS',
  payload: status,
});
export const setSuggestionCompany = (company) => {
  return {
    type: 'SET_SUGGESTION_COMPANY',
    payload: company,
  };
};
export const checkSameUserkLockStatus = (token, boxId) => async dispatch => {
  const api = new Api(token);
  try {
    const response = await api.boxes.checkSameUserkLockStatus(boxId);
    return response;
  } catch (error) {
    return false;
  }
}
export const getLastDcRegistration = (token, boxId) => async dispatch => {
  const api = new Api(token);
  dispatch({ type: 'EPIK_BOXES_SERIAL' });
  try {
    const boxDcRegistration = await api.boxes.getLastDcRegistration(boxId);
    dispatch({ type: 'EPIK_DC_LAST_DATE', boxDcRegistration });
    return boxDcRegistration;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, { toastId: 'EPIK_DC_LAST_DATE' });
    dispatch({ type: 'EPIK_DC_LAST_DATE_ERROR', error });
  }
};
export const getEpikBoxById = (token,boxId,) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'EPIK_BOXES_BY_ID',
  });
  try {
    const box = await api.boxes.getEpikBoxById(boxId);
    return box;
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'EPIK_BOXES_ERROR',
    });
    dispatch({
      type: 'EPIK_BOXES_ERROR',
      error,
    });
  }
};
export const getSalveboxOob = (token, boxId) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.boxes.getSalveboxOob(boxId);
    return data;
  } catch (error) {
    const message_ =
      error?.response?.data?.Response ||
      error?.response?.data ||
      error?.response?.data?.message ||
      ERROR_MESSAGE;
    toast.error(message_);
    return false;
  }
};

export const updateDeviceFeatures = (token, boxId, body) => async (dispatch) => {
  const api = new Api(token);
  try {
    const response = await api.boxes.updateDeviceFeatures(boxId, body);
    return response;
  } catch (error) {
    const message_ =
      error?.response?.data?.Response ||
      error?.response?.data ||
      error?.response?.data?.message ||
      ERROR_MESSAGE;
    toast.error(message_);
    return false;
  }
};
export const updatePortFeature = (token, obiId, boxId, boxPortNumber,deviceId, body) => async (dispatch) => {
    const api = new Api(token);
    try {
      const response = await api.boxes.updatePortFeature(
        obiId,
        boxId,
        boxPortNumber,
        deviceId,
        body,
      );
      return response;
    } catch (error) {
      const message_ =
        error?.response?.data?.Response ||
        error?.response?.data ||
        error?.response?.data?.message ||
        ERROR_MESSAGE;
      toast.error(message_);
      return false;
    }
  };
  export const getBoxDetailById = (token, box) => async dispatch => {
    const api = new Api(token);
    try {
      const boxDetail = await api.boxes.getBoxDetail(box);
      dispatch({
        type: 'BOX_DETAILS_DATA',
        box: boxDetail,
      });
      return boxDetail
    } catch (error) {
      // Error Message from API
      toast.error(error?.response?.data || ERROR_MESSAGE, {
        toastId: 'EPIK_BOXES_ERROR',
      });
      dispatch({
        type: 'EPIK_BOXES_ERROR',
        error,
      });
    }
  };
  export const bulkUpdateCallFeaturePorts = (token, boxId,selectedPorts, sourcePortData) => async (dispatch) => {
    const api = new Api(token);
    try {
      const response = await api.boxes.bulkUpdateCallFeaturePorts(
        boxId,
        selectedPorts, sourcePortData
      );
      return response;
    } catch (error) {
      const message_ =
        error?.response?.data?.Response ||
        error?.response?.data ||
        error?.response?.data?.message ||
        ERROR_MESSAGE;
      toast.error(message_);
      return false;
    }
  };
export const updateFailoverOptions = (token, boxId, body) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.boxes.updateFailoverOptions(boxId, body);
    toast.success("Saved successfully.", {autoClose: 2500 });
    return data;
  } catch (error) {
    // Error Message from API
    if (error === API_OFFLINE_ERROR) {
      toast.error(error, { toastId: API_TOAST_ID });
    }
    else {
      utils.execute510Handler(error, 'GET_INTERFACE_PRIORITY_ERROR');
    }
    return false;
  }
};
export const getFailoverOptions = (token, boxId) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.boxes.getFailoverOptions(boxId);
    return data;
  } catch (error) {
    if (error === API_OFFLINE_ERROR) {
      toast.error(error, { toastId: API_TOAST_ID });
    }
    else {
      utils.execute510Handler(error, 'GET_INTERFACE_PRIORITY_ERROR');
    }
    return false;
  }
};

